export default {
    address: {
        city: "Cidade",
        city_locality: "Cidade\/Localidade",
        country: "País",
        line1: "Endereço Linha 1",
        line2: "Linha de Endereço 2",
        postal_code: "Código postal",
        state: "Estado",
        state_region: "Estado\/Região"
    },
    alerts: {
        account_2fa: "Proteja sua conta com autenticação de dois fatores.",
        account_2fa_success: "A autenticação de dois fatores está ativada.",
        activate_instruction: "Ao ativar a coleta automática de avaliações, tentará solicitar uma avaliação de {count}. Visualize seus modelos antes de ativar.",
        activate_intro: "Solicite continuamente avaliações com base na sua estratégia.",
        agency_mcp_server: "Conecte o Claude ou qualquer cliente MCP ao servidor MCP da sua agência. Assistentes autorizados podem gerenciar os projetos, clientes e equipe da sua agência em seu nome.",
        agency_sso: "Conecte um provedor de identidade OpenID Connect para login do cliente.",
        ai_assistant: "O nome e a descrição da sua empresa são necessários para usar a IA para sugestões de avaliação e respostas.",
        ai_review_pages: "Permita sugestões de avaliação por IA nas páginas que você selecionar.",
        api_key_roll: "Tem certeza de que deseja alterar sua chave de API? Isso afetará qualquer aplicativo que a esteja utilizando.",
        ask_confirm: "Tem certeza de que deseja solicitar avaliações de {count}? Isso agendará solicitações para todos os clientes que ainda não foram consultados.",
        automate_highlights: "Destaque automaticamente frases em novas avaliações positivas.",
        automate_replies: "Publique automaticamente respostas de IA em novas avaliações do Google e do Facebook. Requer uma [integração do Google ou do Facebook](\/settings\/integrations?tab=review).",
        cname_delete: "Tem certeza de que deseja remover o CNAME: {cname_name}?",
        cname_not_configured: "Este registro ainda não foi configurado. Aguarde...",
        cname_warning: "Mensagens que já foram enviadas aos seus clientes terão links quebrados.",
        connection_disabled: "A conexão está desativada. Reconecte-se.",
        customer_archive: "Tem certeza de que deseja arquivar o cliente: {customer_name}? Todas as mensagens não enviadas serão canceladas.",
        customer_cancel: "Tem certeza de que deseja cancelar todas as mensagens não enviadas para o cliente: {customer_name}?",
        customer_ingest: "Inclua este endereço de e-mail no campo BCC ao enviar e-mails para seus clientes para que seus nomes e endereços de e-mail sejam importados automaticamente.",
        customer_resubscribe: "Tem certeza de que deseja inscrever novamente o cliente: {customer_name}?",
        customer_unarchive: "Tem certeza de que deseja desarquivar o cliente: {customer_name}?",
        customer_unsubscribe: "Tem certeza de que deseja cancelar a assinatura do cliente: {customer_name}?",
        customer_unsubscribe_all: "Tem certeza de que deseja cancelar a inscrição de {count} para não receber mensagens deste projeto?",
        delete: "Tem certeza de que deseja excluir {model}: {name}?",
        delete_count: "Tem certeza de que deseja excluir {count}",
        domain_agency: "Adicione seu próprio domínio de envio para tornar sua agência totalmente white label.",
        domain_delete: "Tem certeza de que deseja remover o domínio: {name}? Continuaremos enviando e-mails do nosso próprio domínio.",
        domain_dmarc: "Adicione um registro DMARC ao seu domínio para reduzir a probabilidade de seus e-mails serem classificados como spam.",
        domain_project: "Adicione um domínio de envio para que possamos enviar e-mails aos seus clientes a partir do seu próprio nome de domínio.",
        export_confirm: "Tem certeza de que deseja exportar todos os seus {model}?",
        export_count: "Tem certeza de que deseja exportar {count}?",
        export_link: "Um link para download será enviado para {email} logo após você fazer a solicitação.",
        highlights_save_disabled: "Opcionalmente, você pode remover os destaques de todas as avaliações que os possuem.",
        highlights_save_enabled: "Para destacar todas as avaliações positivas, marque a caixa abaixo. Se você estiver apenas alterando a cor do destaque, deixe a caixa desmarcada.",
        integration_disconnect: "Tem certeza de que deseja desconectar do {integration_name}?",
        integration_sync: "Tem certeza de que deseja sincronizar sua conta {integration_name}? Importaremos seus dados continuamente.",
        intro: "Comece importando seus clientes. Depois, envie os pedidos de avaliação você mesmo, ou deixe que a gente envie por você.",
        intro_help: "Se precisar de ajuda, {demo}.",
        logout: "Tem certeza de que deseja sair?",
        mcp_server: "Conecte Claude ou qualquer cliente MCP a este projeto. O servidor MCP permite que assistentes de IA leiam e gerenciem avaliações, clientes e mensagens em seu nome.",
        member_confirm: "Tem certeza de que deseja se remover? Você perderá o acesso a este projeto.",
        member_confirm_all: "Tem certeza de que deseja se remover? Você perderá o acesso a todos os seus projetos.",
        member_other_confirm: "Tem certeza de que deseja remover {noun}: {name}? Eles perderão o acesso a este projeto.",
        member_other_confirm_all: "Tem certeza de que deseja remover {noun} {name}? Eles perderão o acesso a todos os seus projetos.",
        message_cancel: "Tem certeza de que deseja cancelar esta mensagem?",
        message_cancel_all: "Tem certeza de que deseja cancelar {count}? Esta ação só pode ser realizada em mensagens não enviadas.",
        message_delete: "Tem certeza de que deseja excluir esta mensagem?",
        oauth_client_revoke: "Tem certeza de que deseja revogar o acesso para {client}? Todas as sessões ativas serão desconectadas imediatamente.",
        project_summary: "Não é possível gerar um resumo neste momento.",
        project_suspend: "Tem certeza de que deseja suspender o projeto: {project_name}?",
        project_unsuspend: "Tem certeza de que deseja reativar o projeto: {project_name}?",
        review_delete: "Tem certeza de que deseja excluir esta avaliação? Esta ação não pode ser desfeita.",
        review_page_confirm: "Tem certeza de que deseja salvar suas alterações?",
        review_page_confirmation: "Mostre uma mensagem de confirmação na página de sucesso com base na avaliação selecionada.",
        review_page_default: "Tem certeza de que deseja tornar a página de avaliação: {name} sua página padrão? Esta página será usada se nenhuma outra página for atribuída a uma solicitação de avaliação.",
        review_page_delete: "Tem certeza de que deseja excluir a página de avaliações: {name}? Todos os clientes que estão atualmente direcionados para esta página serão direcionados para a sua página padrão.",
        review_page_delete_all: "Tem certeza de que deseja excluir {count}? Sua página de avaliação padrão não será excluída.",
        review_page_fields: "Use campos para capturar informações do cliente ao deixar uma avaliação. Adicione mais campos ao seu formulário e exiba-os condicionalmente quando os clientes selecionarem uma avaliação.",
        review_page_instructions: "Exibir instruções diretamente acima do formulário após a seleção de uma nota.",
        review_page_location_picker: "Permita que os clientes selecionem qualquer local do seu projeto para a avaliação. Essa opção será pré-selecionada caso a página de avaliação seja exibida para um local específico.",
        review_page_locations: "Selecione os locais que devem usar esta página de avaliação. Um local só pode ser atribuído a uma página de avaliação. Se um local não tiver uma página atribuída, ele usará a página de avaliação padrão.",
        review_page_redirects: "Ignore o formulário após selecionar uma nota e redirecione para outro lugar. Você também pode dividir o tráfego para vários sites adicionando mais de um redirecionamento para cada nota.",
        review_page_review_suggestions: "Ajude os clientes a escrever avaliações com sugestões prontas que eles podem editar antes de enviar.",
        share_template_delete: "Tem certeza de que deseja excluir o modelo de compartilhamento \"{name}\"? Esta ação não pode ser desfeita.",
        smtp_remove: "Tem certeza de que deseja remover a configuração SMTP do seu projeto? Seu domínio de envio retornará à configuração padrão.",
        smtp_setup: "Envie e-mails do seu próprio servidor de e-mail. Insira suas credenciais SMTP. Se o seu servidor usa restrições de IP, adicione os seguintes IPs usados pelo nosso sistema à lista de permissões: {ips}.",
        space_delete: "Tem certeza de que deseja excluir o espaço de trabalho: {name}? Todos os projetos dentro dele serão excluídos.",
        tag_rule: "Adicione um termo positivo e sua contraparte negativa. Se aplicável, usaremos IA para marcar automaticamente a avaliação com um ou outro.",
        user_delete: "Tem certeza de que deseja excluir a conta de usuário de: {email}?",
        user_verify: "Para verificar seu endereço de e-mail e ativar sua conta, clique no link no e-mail enviado para: {email}.",
        widget_delete: "Tem certeza de que deseja excluir o widget: {name}? O widget não será mais exibido em nenhum site.",
        widget_restore: "Tem certeza de que deseja restaurar as configurações do widget: {name}? Somente o design retornará aos valores padrão.",
        widgets_1: "Adicione este script ao corpo do seu site.",
        widgets_2: "O Mural de avaliações exibe todas as suas avaliações em uma grade. Adicione este script onde quiser exibir o widget.",
        widgets_3: "A Avaliação em destaque exibe uma única avaliação em tamanho grande. Adicione este script onde quiser exibir o widget."
    },
    billing_statuses: {
        active: "Sua assinatura está ativa.",
        canceled: "Sua assinatura foi cancelada. Por favor, atualize para continuar.",
        ending: "Sua assinatura termina em {date}.",
        trial: "Seu período de teste gratuito termina em {date}.",
        trial_expired: "Seu período de teste gratuito terminou. Faça o upgrade para continuar.",
        trial_expiring: "Seu período de teste gratuito está terminando em breve. Faça o upgrade para continuar."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "E-mail",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Mensageiro",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Threads",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Adicione um domínio de envio para editar seu endereço de e-mail:",
        agency_robots: "Permita que mecanismos de busca indexem seu portal do cliente.",
        analytics_average_review: "Avaliação média em estrelas neste período.",
        analytics_customers: "Clientes adicionados e clientes solicitados a avaliar pela primeira vez.",
        analytics_limits: "Solicitações de avaliação hoje e neste mês.",
        analytics_location_leaderboard: "Número de avaliações, média e porcentagem de 5 estrelas por local.",
        analytics_needs_attention: "Avaliações de 1 e 2 estrelas dos últimos 3 meses sem resposta.",
        analytics_outreach: "Mensagens enviadas, clicadas e com falha ao longo do tempo.",
        analytics_reply_coverage: "Porcentagem de avaliações que têm resposta.",
        analytics_review_velocity: "Média de avaliações recebidas por semana.",
        analytics_review_volume: "Quantas avaliações você recebeu neste período.",
        analytics_sentiment: "Avaliações escritas classificadas como positivas, neutras ou negativas.",
        analytics_source_mix: "Número de avaliações e média por fonte.",
        analytics_star_mix: "Número de avaliações ao longo do tempo por classificação em estrelas.",
        analytics_tags: "Tags mais usadas neste período, com contagem e média.",
        ai_business_description: "Uma descrição detalhada do seu negócio para ajudar a gerar sugestões de avaliações e respostas.",
        ai_business_name: "O nome da sua empresa.",
        ai_highlights: "Destaque as melhores frases das suas avaliações positivas.",
        ai_highlights_instructions: "Diga à IA quais frases priorizar nos destaques.",
        ai_replies: "Rascunhe e, se quiser, automatize as respostas às suas avaliações.",
        ai_reply_contact: "Incluído nas respostas a avaliações negativas.",
        ai_reply_instructions: "Diga à IA como as respostas devem soar e o que incluir.",
        ai_review_instructions: "Diga à IA o que mencionar ou evitar nas sugestões de avaliação.",
        ai_review_suggestions: "Ajude os clientes a escrever avaliações com sugestões prontas.",
        ai_tags: "Marque automaticamente as avaliações que correspondem às suas instruções.",
        ask_location: "O local a ser atribuído à avaliação.",
        ask_review_page: "A página para capturar a avaliação.",
        assign_tags: "Atribua etiquetas à avaliação.",
        csv_max_rows: "Até {count} Linhas",
        dashboard_configure_settings: "Configure as definições do seu projeto.",
        dashboard_import_customers: "Importe seus clientes.",
        dashboard_preview_email_templates: "Visualize seus modelos de e-mail.",
        dashboard_preview_kiosk_page: "Visualize sua página do quiosque.",
        dashboard_preview_review_page: "Visualize sua página de avaliação.",
        dashboard_preview_showcase_page: "Visualize sua página de apresentação.",
        detect_from_website: "Deixe em branco para detectar a partir do site.",
        logo_height: "A altura do logotipo em e-mails e páginas.",
        meta_description: "Substituir a descrição da página.",
        meta_title: "Substituir o título da página.",
        mfa_password: "Digite a senha da sua conta.",
        mfa_qr_code: "Escaneie o código QR com seu aplicativo autenticador.",
        mfa_security_code: "Digite o código do seu aplicativo autenticador.",
        mcp_server_url: "Cole este URL no Claude, ChatGPT ou em qualquer cliente MCP.",
        other_website_url: "Requisitos:<br>Classificação: 1 a 5 estrelas<br>Data: Nos últimos 2 anos<br>Apenas páginas públicas",
        override_ambassador: "Exiba um emblema nos e-mails, páginas e widgets dos seus clientes.",
        project_name: "O nome da sua empresa, marca ou site.",
        project_robots: "Permita que mecanismos de busca indexem suas páginas de avaliação e as exibam.",
        project_slug: "Usado em e-mails e links voltados ao cliente se um CNAME não estiver configurado.",
        review_page_copied_message: "Exibido após o envio de uma avaliação positiva.",
        review_page_email_address: "Receba avaliações neste e-mail.",
        review_page_link_reveal_position: "Onde revelar os links.",
        review_page_link_revealer_label: "O rótulo para revelar os links.",
        review_page_link_revealer_rating: "Revele links se o cliente selecionar esta nota ou uma superior, caso contrário, mostre um botão para revelá-los.",
        review_page_native_reviews: "Permitir avaliações nesta plataforma.",
        review_page_rating_selection: "Salvar a nota antes de enviar uma avaliação.",
        review_page_success_button_link: "Se estiver em branco, o link padrão será para o site do seu projeto; caso contrário, para o domínio da página.",
        review_page_warning: "Impedir que os clientes deixem avaliações públicas pode fazer com que sua empresa seja removida do cadastro.",
        review_reply_status: "Não podemos responder publicamente a esta avaliação. Em vez disso, entre em contato diretamente com o autor da avaliação.",
        scrape_facebook_url: "Requisitos:<br>Até 100 avaliações recentes<br>Somente páginas públicas",
        scrape_linkedin_url: "Requisitos:<br>Apenas recomendações<br>Apenas páginas públicas",
        scrape_trustpilot_url: "Requisitos:<br>Classificação: 1 a 5 estrelas<br>Somente páginas públicas",
        separate_with_commas: "Separe os múltiplos com vírgulas.",
        setup_basics: "Defina quando e como você pede avaliações aos clientes.",
        setup_business: "Diga-nos o nome pelo qual os clientes o conhecem.",
        setup_google: "Direcione clientes para o seu perfil do Google , responda a avaliações e importe as existentes. Você pode pular esta etapa e fazê-la mais tarde.",
        setup_location_limit: "Seu período de avaliação inclui 1 local. Atualize quando quiser para sincronizar mais locais.",
        showcase_locations: "Limite a exibição a locais específicos.",
        showcase_review_length: "As Avaliações devem ter pelo menos este número de caracteres.",
        showcase_since: "Mostrar avaliações criadas nesta data ou antes dela.",
        showcase_sources: "Limite a apresentação a fontes específicas.",
        showcase_tags: "Limite a exibição a avaliações com etiquetas específicas.",
        signature_html: "Copie e cole a assinatura no seu aplicativo de e-mail.",
        signed_up: "Data de início do cliente.",
        twilio_webhook: "Defina como URL de retorno para seu serviço de mensagens.",
        widget_embed: "O atributo ID do contêiner div onde o widget será exibido."
    },
    labels: {
        accept_all: "Aceitar tudo",
        access_code: "Código de acesso",
        access_codes: "Códigos de acesso",
        account: "Conta",
        account_sid: "SID da conta",
        action: "Ação",
        actions: "Ações",
        activate: "Ativar",
        active: "Ativo",
        add: "Adicionar",
        add_agency_project: "Adicionar um projeto de agência",
        add_confirmation_message: "Adicione uma mensagem de confirmação.",
        add_css_rules: "Adicione suas próprias regras css.",
        add_custom_field: "Adicionar campo personalizado",
        add_customer: "Adicionar um cliente",
        add_customers_with: "Adicionar clientes com {model}",
        add_external_link: "Adicionar um Link externo",
        add_external_links: "Adicionar Links externos",
        add_introduction: "Adicione uma introdução.",
        add_js_tags: "Adicione suas próprias tags JavaScript.",
        add_legal_information: "Adicione informações legais.",
        add_location: "Adicionar um local",
        add_project: "Adicionar um projeto",
        add_review: "Adicionar uma Avaliação",
        add_source: "Adicionar uma fonte",
        add_tag: "Adicionar uma Etiqueta",
        added: "Adicionado",
        address: "Endereço",
        advanced_review_pages: "Páginas de Avaliações avançadas",
        affiliates: "Afiliados",
        age_of_reviews: "Idade das Avaliações",
        agencies: "Agências",
        agency: "Agência",
        agency_name: "Nome da agência",
        agency_project: "Projeto Agência",
        agency_projects: "Projetos de Agência",
        ai: "IA",
        ai_answers: "Respostas de IA",
        ai_assistant: "Assistente de IA",
        ai_auto_tagging: "Marcação por IA",
        ai_highlights_instructions: "Exemplo: Priorize frases sobre o atendimento ou a nossa marca.",
        ai_reply_instructions: "Exemplo: Mantenha as respostas curtas. Convide a entrar em contato se a avaliação for negativa.",
        ai_review_instructions: "Exemplo: Mencione a equipe e a visita. Não mencione preços.",
        ai_review_suggestions: "Sugestões de avaliação de IA",
        ai_reviews_and_replies: "Sugestões e respostas de IA para avaliações",
        ai_tagging_instructions: "Exemplo: Aplique a avaliações que mencionam tempos de espera, serviço lento ou atrasos.",
        ai_tags: "Tags de IA",
        ai_tools: "Ferramentas de IA",
        all: "Todos",
        allowed_domains: "Domínios permitidos",
        amount: "Quantia",
        analytics: "Análise",
        and: "e",
        anonymous_reviews: "Avaliações anônimas",
        answer: "Responder",
        any: "Qualquer",
        api: "API",
        api_key: "Chave de API",
        appearance: "Aparência",
        apply: "Aplicar",
        approved: "Aprovado",
        archive: "Arquivo",
        archive_customer: "Arquivar cliente",
        archived: "Arquivado",
        at_least: "pelo menos",
        at_least_days: "Pelo menos {num} dias",
        at_least_hours: "Pelo menos {num} horas",
        at_least_months: "Pelo menos {num} meses",
        at_most: "no máximo",
        at_most_days: "No máximo {num} dias",
        at_most_hours: "No máximo {num} horas",
        at_most_months: "No máximo {num} meses",
        auth_token: "Token de autenticação",
        authorize: "Autorizar",
        auto_detect: "Auto",
        auto_tags: "Tags de IA",
        automate: "Automatizar",
        automate_highlights: "Automatizar destaques",
        automate_replies: "Respostas automáticas",
        automatic_review_collection: "Coleta Automática de Avaliação",
        automatically_apply_tags: "Aplicar automaticamente a etiqueta às avaliações existentes.",
        automating: "Automatizando",
        avatar: "Avatar",
        avatars: "Avatares",
        average_charge: "Cobrança média",
        average_review: "Avaliação média",
        background_color: "Cor de fundo",
        background_image: "Imagem de fundo",
        back: "Voltar",
        bcc: "BCC",
        bcc_email_address: "Endereço de e-mail BCC",
        best_to_worst: "Do melhor ao pior",
        billing: "Cobrança",
        blog: "The Reviews Guy",
        body: "Conteúdo",
        body_font_size: "Tamanho da fonte do conteúdo",
        bold: "Negrito",
        book_a_demo: "Agendar uma demo",
        bottom: "Fundo",
        bottom_left: "Canto inferior esquerdo",
        bottom_right: "Canto inferior direito",
        build_on: "Construído em {model}",
        business: "Business",
        business_description: "Descrição do negócio",
        business_email: "Endereço de e-mail de suporte",
        business_name: "Nome da empresa",
        business_phone: "Número de telefone de suporte",
        business_website: "Site de negócios",
        button: "Botão",
        button_label: "Etiqueta para Botão",
        button_link: "Link para o Botão",
        button_position: "Posição do Botão",
        button_size: "Tamanho do Botão",
        buy_me_a_coffee: "Compre-me um café",
        by: "por",
        by_signing_up: "Ao criar uma conta, você concorda com nossos termos.",
        call_to_action: "Chamada para ação",
        cancel: "Cancelar",
        cancel_1_message: "Cancelar 1 mensagem",
        cancel_message: "Cancelar mensagem",
        cancel_messages: "Cancelar mensagens {count}",
        cancel_subscription: "Cancelar assinatura",
        cancel_unsent_messages: "Cancelar mensagens não enviadas",
        canceled: "Cancelado",
        center: "Centro",
        change: "Mudar",
        change_key: "Alterar sua chave de API",
        change_plan: "Plano de Mudança",
        changelog: "Registro de alterações",
        channel: "Canal",
        channels: "Canais",
        characters: "Caracteres",
        charges_avg: "A cobrança média deve ser de pelo menos",
        charges_count: "O número de cobranças deve ser de pelo menos",
        charges_sum: "O total de cobranças deve ser de pelo menos",
        chat_with_us: "Fale conosco",
        checkbox: "Caixa de seleção",
        claude: "Claude",
        clear: "Claro",
        clear_highlights_from_reviews: "Remover destaques de todas as avaliações",
        clicked: "Clicado",
        client: "Cliente",
        client_id: "ID do Cliente",
        clients: "Clientes",
        close: "Fechar",
        cloudflare_warning: "Se você usa o Cloudflare, seu proxy deve estar desativado.",
        cname: "CNAME",
        cname_setup_incomplete: "Configuração incompleta - será removida em {date}",
        cname_ssl_pending: "Aguardando certificado SSL",
        cname_status_for: "Status CNAME para",
        code_editor: "Editor de código",
        collapse: "Recolher",
        collect_reviews_anywhere: "Colete avaliações em qualquer lugar",
        color: "Cor",
        colors: "Cores",
        commission_rate: "Taxa de comissão",
        commission_status_approved: "Aprovado",
        commission_status_paid: "Pago",
        commission_status_pending: "Pendente",
        commission_status_reversed: "Invertido",
        community: "Comunidade",
        company: "Empresa",
        complained: "Reclamado",
        confirm_new_password: "Confirmar nova senha",
        confirmation_message: "Mensagem de confirmação",
        configure: "Configurar",
        connect: "Conectar",
        connect_bank: "Conectar conta bancária",
        connect_google: "Conectar o Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Conectado",
        consent_preferences: "Preferências de consentimento",
        contact_customer: "Contato com o cliente",
        contact_form: "Formulário de contato",
        contact_support: "Por favor, entre em contato com o suporte.",
        contact_us: "Contate-nos",
        container_element: "Elemento de contêiner",
        context: "Contexto",
        continue: "Continuar",
        continue_with_google: "Continuar com o Google",
        cookie_category_analytics: "Análises",
        cookie_category_essential: "Essencial",
        cookie_category_functional: "Funcional",
        cookie_category_marketing: "Marketing",
        cookie_consent_banner: "Banner de consentimento de cookies",
        cookie_consent_scope_all: "Mostre para todos",
        cookie_consent_scope_eea: "Exposição exclusiva para visitantes do EEE e do Reino Unido.",
        cookie_consent_scope_none: "Não mostrar",
        cookie_policy: "Política de Cookies",
        cookie_preference: "Preferência de cookies",
        copied: "Copiado",
        copied_message: "Mensagem copiada",
        copy: "Cópia",
        copy_embed_code: "Copiar código de incorporação",
        copy_signature: "Copiar assinatura",
        copy_source_code: "Copiar código-fonte",
        copy_to_all_ratings: "Copiar para todas as avaliações",
        copy_uuid: "Copiar UUID",
        create: "Criar",
        create_account: "Criar uma conta",
        create_agency: "Criar uma Agência",
        create_cname: "Crie um registro CNAME e aponte-o para",
        create_external_link: "Criar um Link externo",
        create_field: "Criar um campo",
        create_link: "Criar um Link",
        create_location: "Criar um local",
        create_project: "Criar um projeto",
        create_qr_code: "Criar código QR",
        create_review: "Criar uma Avaliação",
        create_review_page: "Criar uma Página de Avaliação",
        create_signature: "Criar uma assinatura",
        create_source: "Criar uma fonte",
        create_space: "Criar um espaço de trabalho",
        create_tag: "Criar uma Etiqueta",
        create_tag_rule: "Criar uma regra de Etiqueta",
        create_webhook: "Criar um Webhook",
        create_widget: "Criar um widget",
        created_with_ai_based_on_recent_reviews: "Criado com IA, com base em avaliações recentes",
        crms: "CRMs",
        csv: "CSV",
        currency: "Moeda",
        current_plan: "Plano atual",
        current_year: "Ano atual",
        custom_field: "Campo personalizado",
        custom_instructions: "Instruções personalizadas",
        custom_url: "URL personalizada",
        customer: "Cliente",
        customer_name_convention: "Convenção de Nome do Cliente",
        customer_reviews: "Avaliações de clientes",
        customers: "Clientes",
        customize: "Personalizar",
        customize_review_page: "Personalizar Página de Avaliação",
        daily: "Diário",
        daily_email_requests: "Solicitações diárias de e-mail",
        daily_limit: "Limite Diário",
        daily_requests: "Solicitações diárias",
        daily_sms_requests: "Solicitações diárias de SMS",
        dark: "Escuro",
        dashboard: "Painel de controle",
        date: "Data",
        date_added: "Data adicionada",
        date_canceled: "Data cancelada",
        date_clicked: "Data clicada",
        date_complained: "Data da reclamação",
        date_delivered: "Data de entrega",
        date_failed: "Data Falhou",
        date_messaged: "Data da mensagem",
        date_opened: "Data de abertura",
        date_replied: "Data da resposta",
        date_requested: "Data solicitada",
        date_reviewed: "Data da avaliação",
        date_scheduled: "Data agendada",
        date_sent: "Data de envio",
        date_signed_up: "Data de inscrição",
        date_updated: "Data de atualização",
        dates: "Datas",
        day: "Dia",
        days: "Dias",
        days_after_last_request: "dias após o último pedido",
        days_later: "dias depois",
        deactivate: "Desativar",
        default: "Padrão",
        default_language: "Idioma padrão",
        default_review_page: "Página de Avaliação padrão",
        default_review_visibility: "Visibilidade de Avaliação padrão",
        default_tone: "Tom padrão",
        delay: "Atraso",
        delete: "Excluir",
        delete_1_customer: "Excluir 1 cliente",
        delete_1_review: "Excluir 1 Avaliação",
        delete_1_review_page: "Excluir 1 Página de avaliação",
        delete_1_widget: "Excluir 1 widget",
        delete_agency: "Excluir Agência",
        delete_custom_field: "Excluir campo personalizado",
        delete_customer: "Excluir cliente",
        delete_customers: "Excluir clientes",
        delete_external_link: "Excluir Link externo",
        delete_field: "Excluir campo",
        delete_link: "Excluir Link",
        delete_location: "Excluir local",
        delete_message: "Excluir mensagem",
        delete_n_customers: "Excluir clientes {count}",
        delete_n_review_pages: "Excluir Páginas de avaliação {count}",
        delete_n_reviews: "Excluir Avaliações {count}",
        delete_n_widgets: "Excluir widgets {count}",
        delete_project: "Excluir projeto",
        delete_qr_code: "Excluir código QR",
        delete_reply: "Excluir resposta",
        delete_review: "Excluir Avaliação",
        delete_review_page: "Excluir Página de Avaliação",
        delete_review_pages: "Excluir Páginas de Avaliações",
        delete_reviews: "Excluir Avaliações",
        delete_signature: "Excluir Assinatura",
        delete_source: "Excluir fonte",
        delete_space: "Apagar Espaço",
        delete_tag: "Excluir Etiqueta",
        delete_tag_rule: "Regra de exclusão de Etiqueta",
        delete_template: "Excluir modelo",
        delete_user: "Excluir usuário",
        delete_webhook: "Excluir Webhook",
        delete_widget: "Excluir widget",
        delete_widgets: "Excluir widgets",
        deleted: "Excluído",
        delivered: "Entregue",
        description: "Descrição",
        deselect_all: "Desmarcar tudo",
        disable: "Desabilitar",
        disable_automatic_review_collection: "Desativar a coleta automática de Avaliação",
        disable_field: "Desativar campo",
        disable_when_links_are_visible: "Desativar quando os links estiverem visíveis",
        disabled: "Desabilitado",
        disconnect: "Desconectar",
        disconnect_integration: "Desconectar integração",
        discord_community: "Comunidade Discord",
        display_name: "Nome de exibição",
        dmarc: "DMARC",
        dmarc_status_for: "Status DMARC para",
        do_not_hide_from_public: "Não ocultar do público",
        do_not_send: "Não envie",
        docs: "Documentos",
        documentation: "Documentação",
        domain: "Domínio",
        domain_name: "Nome de domínio",
        dont_have_an_account: "Não tem uma conta?",
        dont_send_thanks: "Não envie agradecimentos",
        done: "Concluído",
        download: "Download",
        download_records: "Baixar registros",
        download_template: "Baixar modelo",
        dpa: "DPA",
        dsar: "DSAR",
        dropdown: "Lista suspensa",
        duplicate: "Duplicado",
        duplicate_project: "Projeto duplicado",
        duplicate_review_page: "Página de Avaliação duplicada",
        duplicate_reviews: "Avaliações duplicadas",
        duplicate_widget: "Widget duplicado",
        edit: "Editar",
        edit_1_customer: "Editar 1 Cliente",
        edit_1_review: "Editar 1 Avaliação",
        edit_client: "Editar Cliente",
        edit_custom_field: "Editar campo personalizado",
        edit_customer: "Editar Cliente",
        edit_customers: "Editar Clientes",
        edit_field: "Campo de edição",
        edit_link: "Editar Link",
        edit_location: "Editar localização",
        edit_member: "Editar membro",
        edit_n_customers: "Editar {count} Clientes",
        edit_n_reviews: "Editar Avaliações {count}",
        edit_notes: "Editar notas",
        edit_qr_code: "Editar código QR",
        edit_reviews: "Editar Avaliações",
        edit_signature: "Editar Assinatura",
        edit_source: "Editar código-fonte",
        edit_strategy: "Estratégia de edição",
        edit_tag: "Editar Etiqueta",
        edit_tag_rule: "Editar regra de Etiqueta",
        edit_tags: "Editar tags",
        edit_team_member: "Membro da Equipe de Edição",
        edit_visibility: "Editar visibilidade",
        edit_webhook: "Editar Webhook",
        editable_ratings: "Classificações editáveis",
        earned: "Merecido",
        eligible: "Elegível",
        email: "E-mail",
        email_address: "Endereço de email",
        email_validation_invalid: "Falha na validação do e-mail",
        email_validation_passed: "Validação de e-mail aprovada",
        email_validation_unknown: "O e-mail não pôde ser verificado",
        emails: "E-mails",
        embed_code: "Código de incorporação",
        enable: "Habilitar",
        enable_automatic_review_collection: "Ativar a coleta automática de Avaliação",
        enable_for_all_reviews: "Habilitar para todas as avaliações",
        enable_for_positive_reviews: "Habilitar avaliações positivas",
        enable_on_review_pages: "Habilitar nas páginas de avaliação",
        enabled: "Habilitado",
        end: "Fim",
        ends: "Termina",
        exclude: "Excluir",
        exclude_email: "Excluir e-mail",
        exclude_sms: "Excluir SMS",
        excluded_channels: "Canais Excluídos",
        expand: "Expandir",
        expired: "Expirado",
        export: "Exportar",
        export_1_customer: "Exportar 1 cliente",
        export_1_review: "Exportar 1 Avaliação",
        export_all: "Exportar tudo",
        export_all_customers: "Exportar todos os clientes",
        export_all_reviews: "Exportar todas as Avaliações",
        export_customers: "Clientes de exportação",
        export_n_customers: "Exportar clientes {count}",
        export_n_reviews: "Exportar {count} Avaliações",
        export_reviews: "Avaliações de exportação",
        external_link: "Link externo",
        external_links: "Links externos",
        extra_locations: "Locais extras",
        faces: "Rostos",
        failed: "Falhou",
        feedback: "Opinião",
        feedback_form: "Formulário de feedback",
        field: "Campo",
        fields: "Campos",
        filter: "Filtro",
        first: "Primeiro",
        first_charged: "Primeiro cobrado",
        first_name: "Primeiro nome",
        first_name_last_initial: "Primeiro nome, última inicial",
        five_star_share: "5 estrelas %",
        flag_as_duplicate: "Marcar como duplicado",
        font: "Fonte",
        font_family: "Família de fontes",
        font_size: "Tamanho da fonte",
        footer: "Rodapé",
        for: "Para",
        forgot_password: "Esqueceu sua senha",
        form: "Forma",
        free: "Livre",
        free_requests_included: "Pedidos gratuitos incluídos",
        from: "de",
        full_name: "Nome completo",
        generate: "Gerar",
        generate_meta: "Gerar Meta",
        generate_qr_code: "Gerar código QR",
        generate_reply: "Gerar resposta",
        generate_review: "Gerar Avaliação",
        generating: "Gerando",
        get_started: "Começar",
        get_started_checklist: "Lista de verificação para começar",
        get_the_lifetime_deal: "Obtenha o acordo vitalício",
        getting_started: "Começando",
        google_fonts: "Fontes do Google",
        grouped_by_request: "Agrupados por solicitação",
        has_links: "Tem Links",
        has_notes: "Contém anotações",
        has_redirects: "Tem redirecionamentos",
        have_an_account: "Tem uma conta?",
        header: "Cabeçalho",
        hidden: "Escondido",
        hidden_from_search_engines: "Oculto dos mecanismos de busca",
        hidden_reviews: "Avaliações ocultas",
        hide: "Esconder",
        hide_all_reviews: "Ocultar todas as avaliações",
        hide_avatar: "Ocultar Avatar",
        hide_date: "Ocultar data",
        hide_drop_shadow: "Ocultar sombra projetada",
        hide_field_label: "Ocultar rótulo do campo",
        hide_from_public: "Ocultar do público",
        hide_name: "Ocultar nome",
        hide_pagination: "Ocultar paginação",
        highlight_color: "Cor de destaque",
        hipaa: "HIPAA",
        host: "Host",
        hours: "Horas",
        icon: "Ícone",
        icon_size: "Tamanho do ícone",
        icons: "Ícones",
        id: "ID",
        image: "Imagem",
        import: "Importar",
        import_address1: "Linha 1 do endereço do cliente.",
        import_address2: "Linha 2 do endereço do cliente.",
        import_city: "A cidade ou localidade do cliente.",
        import_company: "Nome da empresa do cliente.",
        import_created_at: "A data da avaliação.",
        import_customers: "Clientes de importação",
        import_email: "Endereço de e-mail do cliente.",
        import_first_name: "O primeiro nome do cliente.",
        import_from_boost_space: "Importar de Boost.space",
        import_from_hubspot: "Importar do HubSpot",
        import_from_make_com: "Importe de Make.com",
        import_from_pabbly: "Importado de Pabbly",
        import_from_stripe: "Importar do Stripe",
        import_from_zapier: "Importar do Zapier",
        import_last_name: "Sobrenome do cliente.",
        import_list: "Lista separada por vírgulas de",
        import_notes: "Notas para uso interno apenas.",
        import_phone: "O número de telefone do cliente.",
        import_postal_code: "O código postal do cliente.",
        import_recent_reviews: "Importar Avaliações recentes",
        import_review: "O texto da avaliação.",
        import_reviews: "Avaliações de importação",
        import_score: "A nota de 1 a 5.",
        import_signed_up_at: "Data de início do cliente.",
        import_slug: "O slug ou UUID de um",
        import_state: "O estado ou região do cliente.",
        import_yourself: "Importar você mesmo",
        incentive: "Incentivo",
        include: "Incluir",
        include_sample_reviews: "Inclua exemplos de avaliações.",
        incoming_webhook_url: "URL do Webhook de entrada",
        inherit: "Herdar",
        initializing: "Inicializando",
        initials: "Iniciais",
        install_in: "Instalar em",
        insert_variable: "Inserir variável",
        instructions: "Instruções",
        integration: "Integração",
        integrations: "Integrações",
        interval: "Intervalo",
        introduction: "Introdução",
        invite: "Convidar",
        invite_client: "Convidar Cliente",
        invite_failed: "Falha no convite",
        invite_member: "Convidar membro",
        invite_sent_to: "Convite enviado para",
        invite_team_member: "Convidar membro da equipe",
        invited: "Convidado",
        issuer_url: "URL do emissor",
        italic: "itálico",
        joined: "Ingressou",
        key: "Chave",
        keywords: "Palavras-chave",
        keywords_in_replies: "Palavras-chave nas respostas",
        keywords_in_reviews: "Palavras-chave em Avaliações",
        kiosk_page: "Página do quiosque",
        label: "Rótulo",
        label_font_size: "Tamanho da fonte do rótulo",
        labels: "Etiquetas",
        language: "Linguagem",
        languages: "Idiomas",
        large: "Grande",
        last_12_months: "Últimos 12 meses",
        last_2_years: "Últimos 2 anos",
        last_3_months: "Últimos 3 meses",
        last_4_weeks: "Últimas 4 semanas",
        last_6_months: "Últimos 6 meses",
        last_charged: "Última cobrança",
        last_name: "Sobrenome",
        layout: "Layout",
        leave: "Deixar",
        leave_project: "Sair do projeto",
        leave_space: "Deixe Espaço de trabalho",
        left: "Esquerda",
        let_clients_sign_in_with_sso: "Permitir que os clientes entrem com SSO",
        less: "menos",
        lifecycle_stage: "Estágio do ciclo de vida",
        lifetime_deal: "Oferta vitalícia",
        light: "Luz",
        limit: "Limite",
        limits: "Limites",
        link: "Link",
        link_color: "Cor do link",
        link_reveal_position: "Posição de revelação do Link",
        link_revealer_button: "Botão Revelador de Link",
        link_revealer_label: "Rótulo revelador de Link",
        link_revealer_rating: "Nota do revelador de Link",
        links: "Links",
        links_per_review_page: "Links por Página de Avaliação",
        list: "Lista",
        list_unsubscribe_headers: "Cabeçalhos de List-Unsubscribe",
        load_more: "Carregar mais",
        loading: "Carregando",
        location: "Localização",
        location_address: "Localização Endereço",
        location_name: "Nome do local",
        location_picker: "Seletor de localização",
        locations: "Locais",
        locations_limit: "Limite de Locais",
        log_in: "Conecte-se",
        log_out: "Sair",
        logo: "Logotipo",
        logo_height: "Altura do logotipo",
        long: "Longo",
        lowest_rating: "Nota mais baixa",
        ltd: "LTD",
        make_default: "Tornar padrão",
        manage: "Gerenciar",
        manage_limits: "Gerenciar Limites",
        manage_overrides: "Gerenciar substituições",
        manage_payout_account: "Gerenciar conta de pagamento",
        manage_subscription: "Gerenciar assinatura",
        manual_entry: "Entrada manual",
        max: "Máx.",
        max_size: "Tamanho máximo",
        maximum_characters: "Máximo de Caracteres",
        maximum_customers: "Máximo de clientes",
        maximum_locations: "Locais Máximos",
        maximum_members: "Membros Máximos",
        maximum_review_length: "Comprimento máximo da Avaliação",
        maximum_tags: "Número máximo de Etiquetas",
        maximum_widgets: "Máximo de Widgets",
        mcp: "Servidor MCP",
        mcp_server: "Servidor MCP",
        mcp_server_url: "URL do Servidor MCP",
        medium: "Médio",
        member: "Membro",
        members: "Membros",
        menu: "Menu",
        message: "Mensagem",
        message_link_expiration: "Expiração do Link da mensagem",
        messaged: "Mensagem enviada",
        messages: "Mensagens",
        messages_clicked: "Mensagens clicadas",
        messages_sent: "Mensagens enviadas",
        messaging_service_sid: "SID do serviço de mensagens",
        min: "Mínimo",
        min_size: "Tamanho mínimo",
        minimal_delay: "Atraso mínimo",
        minimum_characters: "Caracteres mínimos",
        minutes: "Minutos",
        month: "mês",
        month_to_date: "Mês até hoje",
        monthly: "Mensal",
        monthly_email_requests: "Solicitações mensais por e-mail",
        monthly_limit: "Limite Mensal",
        monthly_pricing_only: "Apenas preços mensais",
        monthly_request_limit: "Limite de solicitação mensal",
        monthly_requests: "Solicitações mensais",
        monthly_sms_requests: "Solicitações mensais de SMS",
        months: "Meses",
        months_free: "{count} Meses grátis",
        more: "mais",
        more_clients: "mais clientes",
        more_customers: "mais clientes",
        more_options: "Mais opções",
        more_patients: "mais pacientes",
        more_reviews: "Mais avaliações",
        more_reviews_needed: "Mais avaliações são necessárias para resumir",
        more_users: "mais usuários",
        more_visitors: "mais visitantes",
        most_negative: "Mais negativos",
        most_positive: "Mais positivos",
        move: "Mover",
        moved: "Movido",
        name: "Nome",
        native_reviews: "Avaliações Nativas",
        negative: "Negativo",
        negative_term: "Termo Negativo",
        new: "Novo",
        new_password: "Nova Senha",
        newest: "Mais recentes",
        neutral: "Neutro",
        no: "Não",
        no_available_options: "Nenhuma opção disponível",
        no_credit_card_required: "Não é necessário cartão de crédito",
        no_data_available: "Nenhum dado disponível",
        no_reminders: "Não envie lembretes",
        no_retries: "Sem novas tentativas",
        no_review: "Nenhuma avaliação",
        none: "Nenhum",
        not_connected: "Não conectado",
        not_reviewed: "Não Avaliado",
        notes: "Notas",
        notifications: "Notificações",
        now: "Agora",
        n_1_ai_tag: "1 tag de IA",
        n_1_review_page: "1 página de avaliação",
        n_ai_tags: "{count} tags de IA",
        n_review_pages: "{count} páginas de avaliação",
        number_of_charges: "Número de cobranças",
        number_of_reminders: "Número de lembretes",
        number_of_retries: "Número de tentativas",
        number_of_review_suggestions: "Número de sugestões de Avaliação",
        of: "de",
        off: "Desligado",
        on: "Ativado",
        on_for_positive_reviews: "Ativado para avaliações positivas",
        on_channel: "no canal {channel}.",
        opened: "Aberto",
        options: "Opções",
        or_log_in_with_email: "ou faça login com seu endereço de e-mail",
        or_sign_up_with_email: "ou use seu endereço de e-mail",
        other_website: "Outro site",
        our_reviews: "Nossas Avaliações",
        output: "Saída",
        page_footer: "Rodapé da página",
        paid: "Pago",
        paragraph: "Parágrafo",
        password: "Senha",
        past_month: "Mês Passado",
        past_months: "Últimos {inc} meses",
        past_week: "Semana Passada",
        past_year: "Ano Passado",
        past_years: "Últimos {inc} anos",
        paused: "Pausado",
        payment_method: "Método de pagamento",
        payout_status_completed: "Concluído",
        payout_status_pending: "Pendente",
        pending: "Pendente",
        pending_deployment: "Implantação pendente",
        pending_validation: "Validação pendente",
        per_day: "por dia",
        per_month: "por mês",
        period: "Período",
        permissions: "Permissões",
        phone: "Telefone",
        phone_number: "Número de telefone",
        pixels: "pixels",
        placeholder: "Espaço reservado",
        placement: "Colocação",
        plan: "Plano",
        plan_bullet1: "Remova nossa marca em e-mails, páginas e widgets",
        plan_bullet2: "Use seu domínio para páginas voltadas ao cliente e envio de e-mails",
        plan_bullet3: "Personalize o produto com a marca branca para agências",
        please_rate_our_service: "Por favor, avalie nosso serviço.",
        png: "PNG",
        policies: "Políticas",
        positive: "Positivo",
        popular: "Popular",
        port: "Porta",
        position: "Posição",
        positive_only: "Somente Avaliações positivas",
        positive_term: "Termo Positivo",
        powered_by: "Distribuído por",
        preview: "Visualização",
        preview_kiosk_page: "Ver página do quiosque",
        preview_review_page: "Ver página de avaliação",
        price: "Preço",
        pricing: "Preços",
        primary_color: "Cor primária",
        priority: "Prioridade",
        privacy_policy: "política de Privacidade",
        proceed_to_dashboard: "Prosseguir para o painel",
        product: "Produto",
        profile: "Perfil",
        project: "Projeto",
        project_name: "Nome do Projeto",
        setup_ask_delay: "Quanto tempo devo esperar antes de pedir uma avaliação?",
        setup_reminders: "Quantos lembretes devo enviar?",
        project_paused: "Este projeto está em pausa.",
        project_suspended: "Este projeto está suspenso.",
        project_website: "Site do projeto",
        projects: "Projetos",
        projects_limit: "Limite de Projetos",
        publish: "Publicar",
        publish_changes: "Publicar as alterações em todas as outras páginas de avaliação",
        published: "Publicado",
        purchase: "Comprar",
        qr_code: "Código QR",
        qr_code_name_placeholder: "Mesa 1, Recepção",
        qr_codes: "Códigos QR",
        quarter_to_date: "Trimestre até hoje",
        quantity: "Quantidade",
        query: "Consulta",
        quick_import: "Importação rápida",
        rating: "Nota",
        rating_order: "Ordem das notas",
        rating_out_of: "nota de",
        rating_save_all: "Salvar nota antes de cada avaliação",
        rating_save_customer: "Salvar nota antes de uma avaliação do cliente",
        rating_save_never: "Nunca salvar a nota antes da avaliação",
        rating_selection: "Seleção de nota",
        rating_selector: "Seletor de nota",
        ratings: "Classificações",
        read: "Ler",
        reapply_highlights_eligible: "Recupere os destaques com IA para todas as avaliações positivas.",
        reconnect: "Reconectar",
        redeem: "Resgatar",
        redirect_uri: "URI de redirecionamento",
        redirects: "Redirecionamentos",
        refer_and_earn: "Indique e ganhe",
        referral_billing_status_active: "Inscrito",
        referral_billing_status_canceled: "Cancelado",
        referral_billing_status_trial: "Teste",
        referral_billing_status_trial_expired: "Período de teste expirado",
        referral_billing_status_trial_expiring: "Período de teste expirando",
        referral_program: "Termos do Programa de Indicação",
        referral_program_terms: "Termos do Programa de Indicação",
        referrals: "Encaminhamentos",
        refresh: "Atualizar",
        regenerate: "Regenerado",
        reject_all: "Rejeitar tudo",
        related_reviews: "Avaliações semelhantes",
        related_similarity: "Semelhança",
        remaining: "Restante",
        reminder: "Lembrete",
        reminders: "Lembretes",
        remove: "Remover",
        remove_client: "Remover Cliente",
        remove_cname: "Remover CNAME",
        remove_domain: "Remover domínio",
        remove_from_project: "Remover do projeto",
        remove_member: "Remover membro",
        remove_smtp_configuration: "Remover configuração SMTP",
        remove_team_member: "Remover membro da equipe",
        rename: "Renomear",
        rename_template: "Renomear modelo",
        renews: "Renova",
        replied: "Respondido",
        reply: "Responder",
        reply_coverage: "Cobertura de respostas",
        reply_to: "Endereço de resposta",
        replying_on: "Respondendo em",
        request: "Solicitação",
        request_1_review: "Solicitar 1 avaliação",
        request_date: "Data da solicitação",
        request_n_reviews: "Solicitar {count} avaliações",
        request_review: "Solicitar uma avaliação",
        request_reviews: "Solicitar avaliações",
        requested: "Solicitado",
        requested_review: "Avaliação solicitada",
        requests: "Solicitações",
        requests_left_this_month: "pedidos deixados este mês",
        requests_remaining: "Solicitações restantes",
        require_field: "Campo obrigatório",
        require_sso: "Exigir SSO",
        required: "Obrigatório",
        reschedule_message: "Reagendar mensagem",
        resend_invite: "Reenviar convite",
        reset_password: "Redefinir senha",
        restore: "Restaurar",
        restore_to_defaults: "Restaurar para os padrões",
        restore_widget: "Widget de restauração",
        resubscribe: "Inscrever-se novamente",
        resubscribe_customer: "Cliente que reativa a inscrição",
        resync: "Ressincronizar",
        resync_account: "Sincronizar novamente a conta",
        resync_now: "Sincronizar novamente agora",
        retries: "Tentativas repetidas",
        reveal_above_form: "Revelar o formulário acima",
        reveal_after_submission: "Revelar após o envio",
        reveal_below_form: "Revelar formulário abaixo",
        review: "Avaliação",
        review_length: "Duração da Avaliação",
        review_link: "Link para Avaliação",
        review_missed: "Avaliação Perdida",
        review_not_requested: "Avaliação não solicitada",
        review_origin: "Esta avaliação foi originada do modelo",
        review_page: "Página de avaliação",
        review_pages: "Páginas de avaliação",
        review_requested: "Avaliação solicitada",
        review_spotlight: "Avaliação em destaque",
        review_suggestion: "Sugestão de Avaliação",
        review_suggestions: "Sugestões de Avaliação",
        review_summary: "Resumo de avaliações",
        review_text: "Texto de Avaliação",
        review_velocity: "Avaliações por semana",
        review_volume: "Volume de avaliações",
        review_wall: "Mural de avaliações",
        reviewed: "Avaliado",
        reviews: "Avaliações",
        reviews_ask: "Perguntar",
        reviews_query_failed: "Algo deu errado. Por favor, tente novamente.",
        reviews_query_placeholder: "Pesquise avaliações ou faça uma pergunta...",
        reviews_with_highlights: "Avaliações com Destaques",
        reviews_with_replies: "Avaliações com Respostas",
        reviews_without_replies: "Avaliações sem respostas",
        revoke: "Revogar",
        revoke_client: "Revogar aplicativo",
        roadmap: "Roteiro",
        role: "Papel",
        sans_serif: "Sans Serif",
        save: "Salvar",
        save_preferences: "Salvar preferências",
        save_template: "Salvar modelo",
        save_template_as_new: "Salvar novo modelo",
        saved: "Salvo",
        schedule: "Agendar",
        schedule_review_request: "Solicitação de avaliação",
        scheduled: "Agendado",
        score: "Pontuação",
        search: "Procurar",
        second: "Segundo",
        secret_key: "Chave Secreta",
        sections: "Seções",
        security_code: "Código de segurança",
        select: "Selecione",
        select_account: "Selecione uma conta",
        select_all: "Selecionar tudo",
        select_an_option: "Selecione uma opção",
        select_bulk_action: "Selecione Ação em Massa",
        select_csv_file: "Selecione o arquivo CSV",
        select_date: "Selecione a data",
        select_field: "Selecione um campo",
        select_icon: "Selecione um ícone",
        select_location: "Selecione um local",
        select_plan: "Selecione um plano",
        select_review: "Selecione uma Avaliação",
        select_source: "Selecione uma fonte",
        select_tag: "Selecione uma Etiqueta",
        selected: "Selecionado",
        send: "Enviar",
        send_1_reminder: "Enviar 1 lembrete",
        send_2_reminders: "Enviar 2 lembretes",
        send_3_reminders: "Enviar 3 lembretes",
        send_anytime: "Enviar a qualquer momento",
        send_between: "Enviar entre",
        send_message: "Enviar mensagem",
        send_retries: "Enviar {count} novas tentativas",
        send_retry: "Enviar {count} Tentar novamente",
        send_test: "Enviar um teste",
        send_thanks: "Enviar agradecimentos",
        sender_email_address: "Endereço de e-mail do remetente",
        sender_id: "ID do remetente",
        sender_name: "Nome do remetente",
        sending_domain: "Domínio de envio",
        sentiment: "Sentimento",
        sent: "Enviado",
        sent_replies: "Respostas enviadas",
        serif: "Serif",
        set_up: "Configurar",
        settings: "Configurações",
        share: "Compartilhar",
        share_link: "Compartilhar Link",
        short: "Curto",
        show: "Mostrar",
        show_1_suggestion: "Mostrar 1 sugestão",
        show_100_results: "Mostrar 100 resultados",
        show_2_suggestions: "Mostrar 2 sugestões",
        show_25_results: "Mostrar 25 resultados",
        show_3_suggestions: "Mostrar 3 sugestões",
        show_4_suggestions: "Mostrar 4 sugestões",
        show_5_suggestions: "Mostrar 5 sugestões",
        show_50_results: "Mostrar 50 resultados",
        show_all_reviews: "Mostrar todas as avaliações",
        show_arrows: "Mostrar setas",
        show_avatar: "Mostrar Avatar",
        show_cookie_consent_banner: "Mostrar banner de consentimento de cookies",
        show_date: "Exibir data",
        show_dots: "Mostrar pontos",
        show_drop_shadow: "Mostrar sombra projetada",
        show_field: "Mostrar campo nas seguintes classificações",
        show_full: "Mostrar estrelas completas",
        show_photo: "Mostrar apenas a foto",
        show_positive_reviews: "Mostrar apenas avaliações positivas",
        show_to_public: "Mostrar ao público",
        showcase: "Showcase",
        showcase_page: "Página de apresentação",
        sign_up: "Inscrever-se",
        sign_up_for_free: "Cadastre-se gratuitamente",
        sign_up_with_email: "Cadastre-se com e-mail",
        sign_in_with_sso: "Entrar com SSO",
        sign_up_with_google: "Cadastre-se com o Google",
        signature: "Assinatura",
        signatures: "Assinaturas",
        signed_up: "Inscrito",
        since: "Desde",
        size: "Tamanho",
        skip: "Pular",
        skipped_required_fields: "Campos obrigatórios ignorados: {fields}",
        slug: "Slug",
        small: "Pequeno",
        sms: "SMS",
        smtp_configuration: "Configuração SMTP",
        sort: "Organizar",
        source: "Fonte",
        source_code: "Código-fonte",
        sources: "Fontes",
        space: "Espaço de trabalho",
        space_name: "Nome do Espaço",
        spaces: "Espaços de trabalho",
        split: "Dividir",
        sso: "SSO",
        star: "Estrela",
        star_color: "Cor da Estrela",
        stars: "Estrelas",
        start: "Começar",
        start_free_trial: "Comece seu teste gratuito",
        start_getting_more_reviews: "Comece a receber mais Avaliações",
        start_over: "Reiniciar",
        status: "Status",
        store_code: "Código da loja",
        strategy: "Estratégia",
        sub_processors: "Subprocessadores",
        subject: "Assunto",
        subscribe: "Inscrever-se",
        subscription: "Assinatura",
        success_page: "Página de Sucesso",
        suggestion: "Sugestão",
        suggestions: "Sugestões",
        summary: "Resumo",
        support: "Suporte",
        suspend: "Suspender",
        suspend_project: "Suspender o projeto",
        suspended: "Suspenso",
        svg: "SVG",
        switch_to_smtp_setup: "Mudar para configuração SMTP",
        switch_to_standard_setup: "Mudar para configuração padrão",
        symbol: "Símbolo",
        sync: "Sincronizar",
        sync_account: "Sincronizar conta",
        sync_now: "Sincronizar agora",
        sync_scheduled_time: "Sincronização agendada {time}",
        sync_with_facebook: "Sincronizar com Facebook",
        sync_with_google: "Sincronizar com Google",
        synced_time: "Sincronizado {time}",
        system: "Sistema",
        system_fonts: "Fontes do sistema",
        tag: "Etiqueta",
        tag_1_customer: "Etiqueta 1 Cliente",
        tag_1_review: "Etiquetar 1 avaliação",
        tag_customers: "Etiquetar clientes",
        tag_existing_reviews: "Etiqueta Avaliações existentes",
        tag_n_customers: "Etiqueta {count} Clientes",
        tag_n_reviews: "Avaliações da Etiqueta {count}",
        tag_reviews: "Etiquetar avaliações",
        tag_rule: "Regra de marcação",
        tag_with_ai: "Marcar com IA",
        tags: "Etiquetas",
        tags_for_customers: "Etiquetas para clientes",
        tags_for_reviews: "Etiquetas para Avaliações",
        team: "Equipe",
        team_member: "Membro da equipe",
        team_members: "Membros da equipe",
        template: "Modelo",
        templates: "Modelos",
        terms_of_service: "Termos de Serviço",
        test_template: "Modelo de teste",
        tests: "Testes",
        text: "Texto",
        text_alignment: "Alinhamento de texto",
        text_color: "Cor do texto",
        thank_you_messages: "Mensagens de agradecimento",
        thanks: "Obrigado",
        theme: "Tema",
        third: "Terceiro",
        time_zone: "Fuso horário",
        timeframe: "Prazo",
        title: "Título",
        tone: "Tom",
        top: "Principal",
        top_left: "Canto superior esquerdo",
        top_right: "Canto superior direito",
        total_charges: "Total de cobranças",
        total_reviews: "Total de Avaliações",
        trend_mentions: "{count} menções, {percent}%",
        trigger: "Acionar",
        trigger_charged: "Enviar solicitação após a cobrança",
        trigger_created: "Enviar solicitação após o cadastro",
        try_free: "Experimente grátis",
        try_it_free: "Experimente grátis",
        type: "Tipo",
        types: "Tipos",
        unarchive: "Desarquivar",
        unarchive_customer: "Desarquivar cliente",
        underline: "Sublinhado",
        unflag_as_duplicate: "Desmarcar como duplicado",
        unknown: "Desconhecido",
        unlimited: "ilimitado",
        unnamed: "Sem nome",
        unpublish: "Despublicar",
        unpublished: "Não publicado",
        unreplied: "Sem resposta",
        unsent_messages: "Mensagens não enviadas",
        unsubscribe: "Cancelar inscrição",
        unsubscribe_1_customer: "Cancelar inscrição de 1 cliente",
        unsubscribe_customer: "Cancelar inscrição do cliente",
        unsubscribe_customers: "Clientes que cancelam a inscrição",
        unsubscribe_n_customers: "Cancelar inscrição de {count} clientes",
        unsubscribe_text: "Texto de cancelamento de inscrição",
        unsubscribed: "Cancelado",
        unsuspend: "Reativar",
        unsuspend_project: "Reativar projeto",
        unverified: "Não verificado",
        update: "Atualizar",
        update_password: "Atualizar senha",
        update_plan: "Plano de atualização",
        update_share_template: "Atualizar modelo",
        updated: "Atualizado",
        updates: "Atualizações",
        upgrade: "Atualizar",
        upgrade_for_more: "Atualize para mais",
        upgrade_to_use: "Por favor, atualize para usar este recurso",
        upload: "Carregar",
        upload_csv: "Carregar arquivo CSV",
        upload_icon: "Carregar um ícone",
        url: "URL",
        use: "Usar",
        use_filters_for_aggregate: "Use filtros para agregação",
        user: "Usuário",
        user_id: "ID do usuário",
        user_info: "Informações do usuário",
        username: "Nome de usuário",
        utc: "UTC",
        validate: "Validar",
        validate_customer_email: "Validar e-mail do cliente",
        validation: "Validação",
        validations: "Validações",
        value: "Valor",
        verify: "Verificar",
        verify_email_address: "Verificar endereço de e-mail",
        view: "Ver",
        view_all: "Ver tudo",
        view_all_features: "Ver todos os recursos",
        view_available_fields: "Ver campos disponíveis",
        view_documentation: "Ver documentação",
        view_email_templates: "Ver modelos de e-mail",
        view_review_pages: "Ver Páginas de Avaliações",
        view_reviews: "Ver Avaliações",
        vs_prior: "vs período anterior",
        view_settings: "Configurações de visualização",
        view_setup_guide: "Consulte o guia de configuração.",
        view_showcase: "Ver Showcase",
        view_strategy: "Estratégia de visualização",
        visibility: "Visibilidade",
        visible: "Visível",
        visible_reviews: "Avaliações visíveis",
        visible_to_search_engines: "Visível para mecanismos de busca",
        wait_between_reminders: "Aguarde entre os lembretes",
        wait_period: "Período de espera",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Site",
        weekly: "Semanalmente",
        weeks: "Semanas",
        widget: "Widget",
        widgets: "Widgets",
        with_ai: "com IA",
        worst_to_best: "Do pior para o melhor",
        would_redirect_to: "Redirecionaria para {url}",
        write: "Escrever",
        written_reviews: "Avaliações escritas",
        year: "ano",
        year_to_date: "Ano até hoje",
        yearly: "Anual",
        yes: "Sim",
        you: "Você",
        your_referral_link: "Seu Link de indicação"
    },
    landing: {
        announcement: "Obtenha relatórios de reputação com nosso servidor MCP",
        counter: "Junte-se a mais de 5.000 negócios locais de serviços",
        counter_agencies: "Usado por mais de 500 agências para gestão de avaliações",
        counter_ai: "Gerencie a reputação de Claude e ChatGPT.",
        ai_screen_1_badge: "MCP",
        ai_screen_1_bullets: [
            "Obtenha respostas sem precisar acessar outro painel.",
            "Utilize a reputação nas ferramentas de chat que sua equipe já usa.",
            "Salvar horas todas as semanas perguntando em vez de cavar."
        ],
        ai_screen_1_subtitle: "Seu trabalho de reputação deve te atender onde você já pensa. Pergunte ao Claude ou ao ChatGPT o que precisa de resposta, a quem perguntar em seguida ou como foi a semana, e obtenha respostas em tempo real sem precisar trocar de ferramenta.",
        ai_screen_1_title: "Pergunte ao Claude ou ChatGPT.",
        ai_screen_2_badge: "Respostas da IA",
        ai_screen_2_bullets: [
            "Responda mais rápido sem parecer genérico.",
            "Nunca deixe avaliações sem resposta quando estiver ocupado.",
            "Proteja a voz da sua marca em todas as suas respostas públicas."
        ],
        ai_screen_2_subtitle: "Cada avaliação não respondida é uma oportunidade perdida de conquistar a confiança dos clientes. A IA redige respostas que soam como você, para que você possa concluir a fila em minutos e se manter presente para os clientes sem o trabalho árduo de escrever.",
        ai_screen_2_title: "Responda sem complicações.",
        ai_screen_3_badge: "Sugestões de IA",
        ai_screen_3_bullets: [
            "Aumente o número de clientes que chegam à linha de chegada.",
            "Reúna feedback específico e que possa ser compartilhado.",
            "Transforme visitas agradáveis em avaliações que valem a pena compartilhar!"
        ],
        ai_screen_3_subtitle: "A maioria das pessoas pretende deixar uma avaliação, mas nunca o faz. Forneça a elas uma linguagem clara e pessoal para que concluam seus textos com mais propriedade e destaquem suas avaliações.",
        ai_screen_3_title: "Obtenha mais avaliações de 5 estrelas",
        ai_screen_4_badge: "Etiquetagem por IA",
        ai_screen_4_bullets: [
            "Identifique padrões antes que se tornem problemas.",
            "Descubra os temas que realmente influenciam as avaliações.",
            "Evite ler centenas de avaliações manualmente."
        ],
        ai_screen_4_subtitle: "Você não precisa reler cada avaliação para entender o que está acontecendo. A IA organiza o feedback nos temas que você considera importantes, permitindo que você corrija problemas mais rapidamente e invista ainda mais naquilo que os clientes adoram.",
        ai_screen_4_title: "Saiba o que os clientes estão dizendo.",
        ai_summary_1_desc: "Escreva respostas no Google e no Facebook que combinem com o seu tom, ou configure respostas automáticas programadas.",
        ai_summary_1_title: "Respostas da IA",
        ai_summary_2_desc: "Ofereça aos clientes sugestões de avaliações prontas para uso quando eles deixarem comentários em sua página.",
        ai_summary_2_title: "sugestões de revisão de IA",
        ai_summary_3_desc: "Destaque as melhores frases em avaliações positivas em widgets, mostre e compartilhe imagens.",
        ai_summary_3_title: "Destaques da IA",
        ai_summary_4_desc: "Aplique etiquetas a partir de regras que você define para que temas como tempo de espera ou qualidade do serviço permaneçam organizados.",
        ai_summary_4_title: "Etiquetagem automática por IA",
        ai_summary_5_desc: "Obtenha resumos concisos de avaliações recentes com contagens, temas e preocupações que merecem atenção.",
        ai_summary_5_title: "Resumos de Avaliação",
        ai_summary_6_desc: "Identifique elogios crescentes e reclamações emergentes sem precisar ler cada avaliação individualmente.",
        ai_summary_6_title: "Tendências positivas e negativas",
        ai_summary_7_desc: "Encontre avaliações semelhantes ao lado de qualquer comentário para que padrões e repetições sejam fáceis de identificar.",
        ai_summary_7_title: "avaliações relacionadas",
        ai_summary_8_desc: "Faça perguntas em linguagem simples sobre suas avaliações e obtenha respostas com citações que você pode consultar.",
        ai_summary_8_title: "Pergunte à IA",
        ai_summary_9_desc: "Conecte o Claude, o ChatGPT e outros clientes MCP para gerenciar a reputação no chat.",
        ai_summary_9_title: "MCP para assistentes",
        ai_summary_10_desc: "Obtenha relatórios de reputação em tempo real, abrangendo volume, avaliações, locais, respostas e alcance.",
        ai_summary_10_title: "Relatórios de reputação",
        ai_summary_11_desc: "Tom guia, palavras-chave e instruções personalizadas para que cada saída de IA soe como a sua marca.",
        ai_summary_11_title: "IA com reconhecimento de marca",
        ai_summary_12_desc: "Avalie o quão positivas ou negativas as avaliações escritas são, além das estrelas, para ordenar o que precisa de atenção.",
        ai_summary_12_title: "Sentimento",
        industries: {
            accountants: "Contadores",
            auto_repair: "Mecânicos de automóveis",
            chiropractors: "Quiropraxistas",
            camps: "Acampamentos",
            cleaning: "Faxineiros",
            contractors: "Empreiteiros",
            dentists: "Dentistas",
            doctors: "Médicos",
            electricians: "Eletricistas",
            financial_advisors: "Consultores financeiros",
            hvac: "Técnicos de climatização",
            insurance_brokers: "Corretores de seguros",
            landscapers: "Paisagistas",
            law_firms: "Advogados",
            locksmiths: "Chaveiros",
            mortgage_brokers: "Corretores de hipotecas",
            optometrists: "Optometristas",
            personal_trainers: "Personal trainers",
            pest_control: "Dedetizadores",
            physical_therapists: "Fisioterapeutas",
            plumbers: "Encanadores",
            real_estate: "Corretores de imóveis",
            restaurants: "Donos de restaurantes",
            salons: "Cabeleireiros",
            self_storage: "Operadores de self storage",
            spas: "Esteticistas",
            preschools: "Escolas infantis",
            tour_guides: "Guias turísticos",
            veterinarians: "Veterinários"
        },
        industries_title: "Gestão de avaliações para negócios locais de serviços",
        stat_1_article: "Relatório de Pesquisa de Consumidores",
        stat_1_desc: "As pessoas querem mais de 100 avaliações antes de confiarem em uma empresa online.",
        stat_1_source: "Salsify",
        stat_1_title: "As Avaliações conquistam a confiança.",
        stat_2_article: "Pesquisa de Avaliação do consumidor local",
        stat_2_desc: "Consumidores que comparam empresas locais preferem aquelas que respondem a todas as avaliações.",
        stat_2_source: "BrightLocal",
        stat_2_title: "Escolha quem responde",
        stat_3_article: "Avaliações, reputação e receita",
        stat_3_desc: "Um pequeno aumento na classificação pode significar um aumento real nos seus ganhos.",
        stat_3_source: "Escola de Negócios de Harvard",
        stat_3_title: "Receita por estrela",
        stat_4_article: "Dependência do consumidor nos resultados de busca da IA",
        stat_4_desc: "Quando as pessoas perguntam à IA em quem investir, suas avaliações ajudam a escrever a resposta.",
        stat_4_source: "Bain & Company",
        stat_4_title: "Confie na Busca por IA",
        subtitle: "Solicite avaliações no piloto automático. Obtenha mais avaliações 5 estrelas. Posicione-se acima da concorrência.",
        agencies_screen_1_badge: "Portal",
        agencies_screen_1_bullets: [
            "Venda um portal personalizado com a sua marca a cada contrato de prestação de serviços.",
            "Mantenha os clientes dentro do seu ecossistema, não em um login de terceiros.",
            "Tenha a aparência de uma empresa de software, sem precisar construir uma."
        ],
        agencies_screen_1_subtitle: "Dê a cada cliente um portal que parece um produto que você criou: sua logo, suas cores, seu domínio. Depois empacote a gestão de avaliações como um serviço recorrente no qual eles entram todo mês. Você não está recomendando uma ferramenta. Está entregando uma.",
        agencies_screen_1_title: "Um portal que eles acham que você criou",
        agencies_screen_2_badge: "Controlar",
        agencies_screen_2_bullets: [
            "Combine as funcionalidades com os pacotes iniciais, de crescimento e premium.",
            "Convide as pessoas certas e controle o que cada cliente vê.",
            "Alterar solicitações, locais e limites por projeto"
        ],
        agencies_screen_2_subtitle: "Nem todo cliente precisa de tudo. Convide equipes para projetos específicos, defina papéis e sobrescreva recursos e limites por conta para que seus pacotes batam com sua cobrança. Faça upsell de acesso conforme crescerem, sem builds sob medida para cada pacote.",
        agencies_screen_2_title: "Controle o acesso por cliente",
        agencies_screen_3_badge: "IA",
        agencies_screen_3_bullets: [
            "Ofereça respostas de IA que salvar horas para seus clientes todas as semanas.",
            "Conecte Claude ou outros assistentes através do MCP de cada projeto.",
            "Transforme a IA em um produto premium para clientes."
        ],
        agencies_screen_3_subtitle: "Não apenas gerencie avaliações. Dê aos clientes IA que redige respostas, marca feedback e funciona com Claude ou outros assistentes via servidor MCP do projeto. É uma capacidade moderna que agências podem empacotar, upsellar e renovar — sem equipe de conteúdo para cada conta.",
        agencies_screen_3_title: "IA pela qual os clientes vão pagar",
        agencies_screen_4_badge: "Escala",
        agencies_screen_4_bullets: [
            "Gerencie avaliações de diversas empresas a partir de uma única conta.",
            "Adicione locais à medida que os conquistar, com preços por volume.",
            "Transforme cada novo cliente em receita recorrente."
        ],
        agencies_screen_4_subtitle: "Um assento de agência. Dezenas de negócios. Rode coleta, respostas e relatórios em cada local de cliente a partir de um hub, e cresça a margem ao adicionar contas. Assim as agências transformam reputação em receita escalável, não em um projeto pontual.",
        agencies_screen_4_title: "Escale em todos os clientes",
        agencies_summary_10_desc: "Conecte Claude ou outros assistentes para gerenciar projetos, clientes e equipe.",
        agencies_summary_10_title: "Agência MCP",
        agencies_summary_11_desc: "Cada cliente recebe o pacote completo de ferramentas de avaliação: coleção, IA, widgets e muito mais.",
        agencies_summary_11_title: "Tudo sobre negócios",
        agencies_summary_12_desc: "Obtenha ajuda de uma equipe que entende os fluxos de trabalho da agência e as implementações para clientes.",
        agencies_summary_12_title: "Suporte dedicado",
        agencies_summary_1_desc: "Os Clientes gerenciam a reputação em um portal que se parece com um produto que você desenvolveu.",
        agencies_summary_1_title: "Portal do cliente personalizado",
        agencies_summary_2_desc: "Execute o portal em seu domínio para que todos os logins permaneçam vinculados à sua marca.",
        agencies_summary_2_title: "Domínio de agência personalizada",
        agencies_summary_3_desc: "Permita que os clientes façam login com seu provedor de identidade com um único clique.",
        agencies_summary_3_title: "Autenticação única",
        agencies_summary_4_desc: "Convide clientes para projetos específicos e controle o que eles podem ver.",
        agencies_summary_4_title: "Convites e funções do Cliente",
        agencies_summary_5_desc: "Defina limites para solicitações, locais e recursos por projeto, de forma a corresponder aos seus pacotes.",
        agencies_summary_5_title: "Substituições por projeto",
        agencies_summary_6_desc: "Dê à sua equipe interna acesso total a todos os projetos dos clientes.",
        agencies_summary_6_title: "Vagas para a equipe da agência",
        agencies_summary_7_desc: "Comece com 5 locais e, à medida que crescer, adicione mais com preços por volume.",
        agencies_summary_7_title: "Escala de múltiplas localizações",
        agencies_summary_8_desc: "As notificações do sistema são enviadas a partir do domínio da sua agência e por projeto, quando os clientes não adicionaram o seu próprio domínio.",
        agencies_summary_8_title: "Envio de marca branca",
        agencies_summary_9_desc: "Automatize projetos, clientes e equipes com a API da Agência.",
        agencies_summary_9_title: "API da Agência",
        demo_footer: "Escolha um horário que funcione para você. Vamos te guiar por tudo e responder suas perguntas.",
        desc_contact: "Tem uma dúvida ou precisa de ajuda com algo? Envie uma mensagem abaixo e nós cuidamos do resto.",
        mcp_aria: "Demonstração de assistente de IA conectada ao More Good Reviews via MCP",
        mcp_prompts_aria: "Exemplos de perguntas",
        review_flow_aria: "Carrossel de cartões exibindo solicitações de avaliação por e-mail, a página de avaliação, avaliações do Google e feedback privado.",
        review_flow_autopilot: "Funciona em piloto automático.",
        review_flow_card_email_desc: "Ao finalizar o atendimento a um cliente, enviamos automaticamente um e-mail personalizado com um link de fácil acesso para a sua página de avaliações.",
        review_flow_card_email_title: "Enviar a solicitação",
        review_flow_card_feedback_desc: "Avaliações mais baixas geram feedback privado primeiro, para que você possa corrigir o problema. Os Clientes ainda optam por deixar uma avaliação pública.",
        review_flow_card_feedback_title: "Receba feedbacks difíceis",
        review_flow_card_google_desc: "Clientes satisfeitos têm um caminho claro para deixar uma avaliação pública no Google , garantindo que os elogios apareçam onde novos clientes procuram.",
        review_flow_card_google_title: "Envie elogios ao Google",
        review_flow_card_review_desc: "Eles acessam sua página de avaliações, escolhem uma classificação e a próxima etapa depende de como foi a experiência.",
        review_flow_card_review_title: "O Cliente escolhe uma classificação.",
        review_flow_next: "Próximo passo",
        review_flow_prev: "Etapa anterior",
        review_flow_step_email: "Solicitação uma Avaliação",
        review_flow_step_feedback: "ou solicite feedback",
        review_flow_step_google: "Como acessar qualquer site de Avaliação",
        review_flow_step_review: "Solicitar Nota",
        review_flow_steps_aria: "Etapas da solicitação de Avaliação",
        summary_10_desc: "Organize clientes e avaliações para que você possa filtrar e agir rapidamente.",
        summary_10_title: "Etiquetagem de Cliente e avaliações",
        summary_11_desc: "O Zapier integra o More Good Reviews às ferramentas que você já usa.",
        summary_11_title: "Conecte-se a qualquer aplicativo",
        summary_12_desc: "Gerencie a reputação do Claude, ChatGPT e outros clientes MCP .",
        summary_12_title: "MCP para assistentes de IA",
        summary_1_desc: "Envio programado de e-mails e SMS com lembretes, em piloto automático.",
        summary_1_title: "Solicitações de revisão automática",
        summary_2_desc: "E-mails e SMS que combinam com sua marca, tom de voz e oferta.",
        summary_2_title: "Modelos de marca",
        summary_3_desc: "Recolha feedback privado ou encaminhe as pessoas para o Google, Facebook e outras plataformas.",
        summary_3_title: "Páginas de Avaliação",
        summary_4_desc: "Códigos imprimíveis e retirada na loja em tela cheia.",
        summary_4_title: "Códigos QR e quiosque",
        summary_5_desc: "Incorpore avaliações e avaliações em qualquer lugar do seu site.",
        summary_5_title: "Widgets do site",
        summary_6_desc: "Uma página pública e personalizável para suas melhores avaliações.",
        summary_6_title: "Página de Showcase",
        summary_7_desc: "Importar avaliações e responda a partir de um único lugar.",
        summary_7_title: "Sincronização do Google e do Facebook",
        summary_8_desc: "Sugestões na página que ajudam os clientes a deixar uma avaliação.",
        summary_8_title: "Ajuda na redação de avaliações de IA",
        summary_9_desc: "Escreva respostas, resumos, veja tendências e consulte a IA sobre suas avaliações.",
        summary_9_title: "Respostas e insights da IA",
        subtitle_agencies_feature_summary: "Portal white label, acesso de clientes, escala e automação sob a sua marca.",
        subtitle_ai_feature_summary: "Respostas, marcação, insights e assistentes integrados ao seu fluxo de trabalho de reputação.",
        subtitle_feature_summary: "Coleta, exibição, IA e integrações — prontos quando você estiver.",
        subtitle_mcp: "Conecte Claude, ChatGPT e outros clientes MCP e pergunte sobre avaliações, locais e outreach em linguagem natural.",
        subtitle_review_flow: "Peça avaliações automaticamente. Os clientes podem deixar uma avaliação pública a qualquer momento. O feedback privado é opcional.",
        title: "Gestão de reputação com IA para",
        title_agencies: "Transforme avaliações em",
        title_agencies_feature_summary: "Tudo o que as agências precisam",
        title_agencies_phrases: {
            branded_product: "um produto da sua marca",
            recurring_retainers: "retainers mensais recorrentes",
            revenue_stream: "uma nova fonte de receita"
        },
        title_ai: "Pergunte à sua IA",
        title_ai_feature_summary: "Tudo o que a IA pode fazer por você",
        title_ai_phrases: {
            weekly_report: "para um relatório semanal de reputação",
            send_from_chat: "para enviar solicitações de avaliação",
            next_steps: "para os próximos passos a serem tomados."
        },
        title_contact: "Como podemos ajudar?",
        faq_location_pricing_a: "No Business, você paga por local com descontos por volume conforme cresce (a partir de US$ 59\/local\/mês, ou US$ 49\/mês no plano anual), e cada local inclui 5.000 solicitações de avaliação por mês. O Agency inclui 5 locais e 25.000 solicitações; locais extras custam US$ 12\/mês e cada um adiciona 5.000 solicitações.",
        faq_location_pricing_q: "Como funciona o preço por local?",
        title_faq: "Perguntas frequentes",
        title_feature_summary: "Tudo na caixa",
        title_footer: "Pare de correr atrás de avaliações. Comece a conquistá-las.",
        title_footer_ai: "sobre sua reputação",
        title_ltd: "Pague uma vez e use para sempre com nossa oferta vitalícia por tempo limitado",
        title_mcp: "Pergunte à IA sobre sua reputação",
        title_review_flow: "Transforme ótimas experiências em avaliações",
        title_phrases: {
            autopilot: "pedir avaliações no piloto automático",
            google_reviews: "conseguir mais avaliações no Google",
            suggested_by_chatgpt: "ser sugerido pelo ChatGPT"
        },
        title_pricing: "Todas as funcionalidades. Preços simples.",
        title_reviews: "Não acredite só na nossa palavra"
    },
    plans: {
        additional_locations_tooltip: "Adicione mais locais conforme cresce. O Business cobra cada local a partir de US$ 59\/mês (incluindo o primeiro), com um valor anual menor. Locais extras do Agency custam US$ 12\/mês além dos 5 incluídos, e cada extra adiciona 5.000 solicitações mensais.",
        agency: {
            agency_api: "API da Agência",
            branded_portal: "Portal do cliente personalizado",
            client_invites: "Convites, funções e substituições de Cliente",
            custom_domain: "Domínio de agência personalizado",
            everything_in_business: "Tudo no plano de negócios",
            locations_included: "5 locais incluídos",
            review_requests: "5.000 pedidos de avaliação por local por mês",
            sso: "Autenticação única (SSO)",
            support: "Suporte ao cliente dedicado",
            volume_pricing: "US$ 12\/mês por local extra"
        },
        business: {
            ai: "Respostas, insights e perguntas da IA.",
            api_mcp: "Servidor API e MCP",
            custom_domains: "Domínios personalizados para e-mail e páginas de avaliação",
            google_facebook: "Perfil da empresa no Google e Facebook",
            locations_included: "1 local incluído",
            review_requests: "{count} solicitações de revisão \/ local \/ mês",
            support: "Suporte ao cliente dedicado",
            unlimited_customers: "Clientes ilimitados",
            volume_pricing: "Preços por volume a partir de US$ 59\/mês"
        },
        descriptions: {
            agency: "Para agências que gerenciam a reputação de seus clientes sob a própria marca. Cinco locais inclusos, depois US$ 12 por local extra, além de um portal personalizado e acesso para clientes.",
            business: "Para empresas que gerenciam sua própria reputação. Pague por local com descontos por volume e obtenha inteligência artificial, integrações e clientes ilimitados inclusos."
        },
        selectors: {
            agency_extras_flat: "Locais extras · {price}\/{month} cada",
            agency_included: "{count} locais incluídos",
            agency_tier: "+{from}–{to} locais · {price}\/{month} cada",
            agency_tier_plus: "+{from}+ locais · {price}\/{month} cada",
            business_tier: "Locais {from}–{to} · {price}\/{month} cada",
            business_tier_plus: "{from}+ locais · {price}\/{month} cada"
        }
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Adicione um cliente e solicite uma avaliação.",
            customers_to_ask: "Encontre clientes para solicitar avaliações.",
            location_leaderboard: "Comparar o desempenho da localização",
            outreach_health: "Auditar a saúde da entrega de solicitações",
            review_digest: "Resumo semanal",
            send_review_requests: "Envie solicitações de avaliação em massa."
        },
        texts: {
            add_customer_and_ask: "Adicione um novo cliente usando os dados de contato que eu lhe fornecer e, em seguida, agende uma solicitação de avaliação para ele por e-mail com 2 lembretes.",
            customers_to_ask: "Liste até 50 clientes que nunca foram solicitados a deixar uma avaliação, ordenados por data de inscrição, do mais recente para o mais antigo. Ignore os clientes que cancelaram a inscrição. Inclua nome, e-mail e data de inscrição.",
            import_customer: "Adicione {name} como cliente. O e-mail dele é {email}.",
            import_customer_reply: "Adicionado {name}.",
            import_review: "Adicione uma avaliação de 5 estrelas de {name}: A equipe foi profissional e os resultados foram excelentes.",
            import_review_reply: "Adicionada a avaliação de 5 estrelas de {name}.",
            location_leaderboard: "Crie um ranking de 90 dias por localização com contagem de avaliações, nota média, porcentagem de avaliações de 5 estrelas e tendência em comparação com os 90 dias anteriores. Classifique por nota e sinalize qualquer queda superior a 0,2 estrelas.",
            outreach_health: "Para as mensagens de e-mail enviadas nos últimos 14 dias, informe o total enviado, a taxa de entrega, a taxa de abertura, a taxa de cliques e a taxa de falhas. Sinalize quaisquer anomalias.",
            review_digest: "Resuma todas as avaliações dos últimos 7 dias. Inclua a quantidade, a nota média, a distribuição por fonte e localização, os 3 principais temas e as 3 principais preocupações.",
            send_review_requests: "Para clientes que se cadastraram nos últimos 30 dias e ainda não foram contatados, agende uma solicitação de avaliação por e-mail com 2 lembretes. Mostre a lista primeiro e aguarde minha confirmação."
        }
    },
    messages: {
        activated: "Ativado com sucesso.",
        archived: "Arquivado com sucesso.",
        canceled: "Cancelado com sucesso.",
        cannot_copy: "Não é possível copiar para a área de transferência",
        cname_active: "O status CNAME está ativo.",
        cname_not_active: "O status CNAME ainda não está ativo.",
        connected: "Conectado com sucesso.",
        cookie_banner_text: "Usamos cookies para melhorar sua experiência. Você pode personalizar suas preferências ou aceitar todos.",
        cookie_category_analytics_desc: "Utilizados para medir o tráfego do site e a utilização dos produtos. Esses cookies nos ajudam a entender como os visitantes usam nosso site.",
        cookie_category_essential_desc: "Sempre ativos. Esses cookies são necessários para o funcionamento do site e não podem ser desativados.",
        cookie_category_functional_desc: "Ative recursos avançados, como o chat ao vivo. Esses cookies não rastreiam você para fins publicitários.",
        cookie_category_marketing_desc: "Utilizado para publicidade e medição de campanhas. Isso pode incluir pixels de anúncios e ferramentas de atribuição.",
        copied: "Copiado com sucesso.",
        copied_to_all_ratings: "Copiado para todas as avaliações. Salve para aplicar.",
        created: "Criado com sucesso.",
        deactivated: "Desativado com sucesso.",
        deleted: "Excluído com sucesso.",
        disconnected: "Desconectado com sucesso.",
        duplicated: "Duplicado com sucesso.",
        error: "Algo deu errado. Por favor, tente novamente.",
        google_connect_failed: "Não foi possível conectar ao Google. Você pode tentar novamente ou ignorar por enquanto.",
        inquiry_sent: "Obrigado pela sua mensagem. Entraremos em contato em breve.",
        oauth_consent_intro: "{client} está solicitando permissão para acessar sua conta.",
        oauth_request_missing: "A solicitação de autorização OAuth está ausente ou expirou.",
        operation_analytics_rebuild_failed: "Não foi possível criar a análise.",
        operation_analytics_rebuild_progress: "Criando sua análise…",
        operation_analytics_rebuild_success: "A análise está pronta.",
        operation_connection_sync_failed: "A sincronização de {integration_name} falhou.",
        operation_connection_sync_progress: "Sincronizando {integration_name}…",
        operation_connection_sync_success: "Sincronização {integration_name} concluída.",
        operation_customer_import_failed: "A importação do Cliente falhou.",
        operation_customer_import_progress: "Importando clientes…",
        operation_customer_import_success: "Importação do Cliente concluída.",
        operation_review_import_failed: "A importação da Avaliação falhou.",
        operation_review_import_progress: "Importando avaliações…",
        operation_review_import_success: "Avaliação da importação concluída.",
        operation_review_scrape_failed: "A importação da avaliação recente falhou.",
        operation_review_scrape_progress: "Importando avaliações recentes…",
        operation_review_scrape_success: "Importação da avaliação recente concluída.",
        processed: "Processado com sucesso.",
        published: "Publicado com sucesso.",
        purchased: "Comprado com sucesso.",
        queued: "Agendado com sucesso.",
        refreshed: "Atualizado com sucesso.",
        removed: "Removido com sucesso.",
        resubscribed: "Reinscrição realizada com sucesso.",
        revoked: "Revogado com sucesso.",
        saved: "Salvo com sucesso.",
        scheduled: "Agendado com sucesso.",
        sent: "Enviado com sucesso.",
        started: "Iniciado com sucesso.",
        stopped: "Parado com sucesso.",
        sso_failed: "Não foi possível autorizar com SSO.",
        sso_invalid_callback: "Retorno de chamada SSO inválido.",
        sso_not_configured: "O SSO não está configurado.",
        sso_openid_config_failed: "Não foi possível carregar a configuração OpenID.",
        sso_token_exchange_failed: "Não foi possível concluir a troca de tokens SSO.",
        subscribed: "Inscrito com sucesso.",
        suspended: "Suspenso com sucesso.",
        synced: "Sincronizado com sucesso.",
        unarchived: "Desarquivado com sucesso.",
        unpublished: "Não publicado com sucesso.",
        unscheduled: "Desprogramado com sucesso.",
        unsubscribed: "Inscrição cancelada com sucesso.",
        unsuspended: "Reativado com sucesso.",
        updated: "Atualizado com sucesso.",
        upgraded: "Atualizado com sucesso.",
        validated: "Validado com sucesso.",
        verified: "Verificado com sucesso."
    },
    notices: {
        agency: "Tem uma agência? Você pode usar a marca branca do nosso produto para que seus clientes vejam apenas a sua marca ao usar o serviço.",
        ai_tags: "Crie uma tag de IA para que as avaliações que correspondam às instruções sejam marcadas automaticamente.",
        connected_apps: "Os aplicativos que você conectar através do MCP aparecerão aqui.",
        connector: "Importe seus clientes de milhares de aplicativos com {brand}.",
        customer_messages: "Solicite uma avaliação para agendar mensagens.",
        customer_reviews: "Solicite uma avaliação deste cliente.",
        customers: "Importe seus clientes para que comecem a solicitar avaliações.",
        customers_import_yourself: "Importe seus clientes para que comecem a solicitar avaliações. Você também pode importar a si mesmo primeiro para experimentar o processo antes de convidar outras pessoas.",
        external_links: "Adicione links externos ao seu portal do cliente para ajudar a vender seus serviços. Esses links serão exibidos aos seus clientes na barra lateral.",
        links: "Adicione botões à sua página para deixar avaliações em sites de terceiros.",
        locations: "Crie um local para que você possa atribuir avaliações a vários locais.",
        ltd: "Desbloqueie o acesso vitalício com seu código de acesso. Cada código inclui um número limitado de solicitações mensais, além de todos os recursos. Os códigos são cumulativos. 3 ou mais códigos desbloqueiam o plano de agência. Insira seus códigos de acesso abaixo.",
        mcp_example_prompts: "Após conectar-se ao servidor MCP , cole estas informações no seu assistente como ponto de partida.",
        messages: "Todas as solicitações e lembretes aparecerão aqui quando avaliações forem solicitadas dos seus clientes.",
        no_commissions: "Você ainda não ganhou nenhuma comissão.",
        no_payouts: "Os pagamentos são enviados manualmente assim que seu saldo aprovado atingir pelo menos US$ 50,00 e sua conta bancária estiver conectada.",
        no_projects: "Você ainda não foi atribuído a um projeto. Entre em contato com o administrador para obter acesso.",
        no_referrals: "Você ainda não indicou ninguém. Compartilhe seu link de indicação para começar.",
        qr_codes: "Crie códigos QR com cores, locais e etiquetas personalizados. Faça o download em formato SVG ou PNG.",
        referrals_share_subject: "Meu Gerenciador de Reputação de IA",
        referrals_share_text: "Minha arma secreta para conseguir avaliações de negócios: More Good Reviews. Gestão de reputação com IA que realmente funciona. Cadastre-se pelo meu link:",
        review_pages: "Seu projeto pode ter várias páginas de avaliação para seus clientes deixarem avaliações. Isso é útil para empresas com mais de uma filial.",
        reviews: "Estamos aguardando avaliações de seus clientes.",
        showcase: "Estamos apenas começando.",
        signatures: "Crie uma assinatura de e-mail para copiar e colar no seu aplicativo de e-mail.",
        sources: "Crie uma fonte para que você possa categorizar suas avaliações.",
        tag_rules: "Crie uma regra para categorizar suas avaliações automaticamente com IA.",
        tags: "Crie uma etiqueta para categorizar suas avaliações e seus clientes.",
        unauthorized: "Você não tem permissão para acessar esta página.",
        unsubscribed: "Você cancelou a inscrição para receber solicitações de avaliação.",
        webhooks: "Adicione webhooks para ser notificado sobre eventos da plataforma.",
        widgets: "Crie widgets para incorporar avaliações em seu site.",
        your_referral_link_text: "Compartilhe seu link para ganhar {rate}% de comissão recorrente em cada pagamento de clientes que você indicar. Os pagamentos são enviados manualmente assim que seu saldo aprovado atingir pelo menos US$ 50,00."
    },
    notification_types: {
        descriptions: {
            imports: "Enviado quando as importações forem concluídas.",
            new_reviews: "Enviado quando as avaliações forem recebidas.",
            sent_replies: "Enviado quando as avaliações são respondidas automaticamente.",
            weekly_reports: "Um resumo das atividades é enviado semanalmente."
        },
        names: {
            imports: "Importações",
            new_reviews: "Novas Avaliações",
            sent_replies: "Respostas enviadas",
            weekly_reports: "Relatórios Semanais"
        }
    },
    roles: {
        admin: "Administrador",
        manager: "Gerente",
        operator: "Operador",
        owner: "Proprietário",
        super_admin: "Superadministrador",
        viewer: "Visualizador"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Aceitar convite",
        accepting_invite: "Aceitando convite",
        access_denied: "Acesso negado",
        account: "Conta",
        actions: "Ações",
        add_custom_field: "Adicionar campo personalizado",
        add_ons: "Complementos",
        address: "Endereço",
        agencies: "Agências",
        agency: "Agência",
        ai: "IA",
        ai_assistant: "Assistente de IA",
        ai_highlights: "Destaques da IA",
        ai_replies: "Respostas de IA",
        ai_review_suggestions: "Sugestões de Avaliação de IA",
        ai_tags: "Tags de IA",
        ai_tools: "Ferramentas de IA",
        analytics: "Análise",
        api: "API",
        api_key: "Chave de API",
        appearance: "Aparência",
        application_connectors: "Conectores de Aplicativos",
        attributes: "Atributos",
        authorize: "Autorizar",
        auto_tagging: "Marcação automática",
        automate: "Automatizar",
        automatic_review_collection: "Coleta Automática de Avaliação",
        billing: "Cobrança",
        branding: "Marca",
        change_password: "Alterar a senha",
        clients: "Clientes",
        cname: "CNAME",
        conditions: "Condições",
        confirmation_message: "Mensagem de confirmação",
        connected_apps: "Aplicativos Conectados",
        contact_us: "Contate-nos",
        cookie_policy: "Política de Cookies",
        cookie_preferences: "Preferências de cookies",
        copy: "Cópia",
        create_your_account: "Crie sua conta",
        crms: "CRMs",
        css: "CSS",
        custom_field: "Campo personalizado",
        custom_fields: "Campos personalizados",
        custom_icons: "Ícones personalizados",
        customer: "Cliente",
        customer_facing_pages: "Páginas de atendimento ao cliente",
        customers: "Clientes",
        dashboard: "Painel de controle",
        details: "Detalhes",
        dmarc: "DMARC",
        domain: "Domínio",
        dpa: "Acordo de Processamento de Dados",
        dsar: "Solicitação de acesso do titular dos dados",
        email_address: "Endereço de email",
        email_messages: "Mensagens de e-mail",
        email_settings: "Configurações de e-mail",
        email_usage: "Uso de e-mail",
        emails: "E-mails",
        embed_code: "Código de incorporação",
        example_chat: "Exemplo de bate-papo",
        examples: "Exemplos",
        export: "Exportar",
        external_link: "Link externo",
        external_link_num: "Link externo #{num}",
        external_links: "Links externos",
        features: "Recursos",
        feedback_form: "Formulário de feedback",
        field: "Campo",
        fields: "Campos",
        filters: "Filtros",
        form_fields: "Campos de formulário",
        got_access_code: "Tem um código de acesso?",
        hipaa: "Declaração HIPAA",
        how_it_works: "Como funciona",
        incentive: "Incentivo",
        instructions: "Instruções",
        integration: "Integração",
        integrations: "Integrações",
        javascript: "JavaScript",
        latest_reviews: "Últimas Avaliações",
        location_leaderboard: "Ranking de locais",
        lifetime_deal: "Oferta vitalícia",
        limits: "Limites",
        link: "Link",
        links: "Links",
        location: "Localização",
        location_picker: "Seletor de localização",
        locations: "Locais",
        log_in: "Conecte-se",
        log_out: "Sair",
        make_default: "Tornar padrão",
        manage_limits: "Gerenciar Limites",
        manage_overrides: "Gerenciar substituições",
        manage_review: "Gerenciar Avaliação",
        mcp_example_prompts: "Exemplos de perguntas",
        mcp_server: "Servidor MCP",
        message: "Mensagem",
        messages: "Mensagens",
        meta: "Meta",
        no_clients: "Nenhum cliente",
        no_commissions: "Sem comissões",
        no_connected_apps: "Nenhum aplicativo conectado",
        no_custom_fields: "Sem campos personalizados",
        no_customers: "Nenhum cliente",
        no_links: "Sem Links",
        no_locations: "Nenhum local",
        no_members: "Nenhum membro",
        needs_attention: "Precisa de atenção",
        no_messages: "Nenhuma mensagem",
        no_payouts: "Sem pagamentos",
        no_projects: "Nenhum Projeto",
        no_qr_codes: "Sem códigos QR",
        no_referrals: "Sem encaminhamentos",
        no_review_pages: "Nenhuma Páginas de Avaliações",
        no_reviews: "Nenhuma Avaliações",
        no_tags: "Sem Etiquetas",
        no_team_members: "Nenhum membro da equipe",
        no_template: "Sem modelo",
        no_widgets: "Sem widgets",
        notifications: "Notificações",
        options: "Opções",
        overview: "Visão geral",
        payment_method: "Método de pagamento",
        photo: "Foto",
        plans: "Planos",
        powered_by: "Distribuído por",
        pricing: "Preços",
        privacy_policy: "política de Privacidade",
        profile: "Perfil",
        project: "Projeto",
        project_limits: "Limites do Projeto",
        project_overrides: "Substituições de Projeto",
        projects: "Projetos",
        qr_code: "Código QR",
        qr_codes: "Códigos QR",
        ratings: "Classificações",
        redeem_access_code: "Resgatar código de acesso",
        redirecting: "Redirecionando",
        redirects: "Redirecionamentos",
        referrals_commissions: "Comissões",
        referrals_payouts: "Pagamentos",
        referral_program: "Termos do Programa de Indicação",
        reminders: "Lembretes",
        reply: "Responder",
        request: "Solicitação",
        request_options: "Opções de solicitação",
        requests: "Solicitações",
        required: "Obrigatório",
        reschedule_message: "Reagendar mensagem",
        reset_password: "Redefinir senha",
        resource_limits: "Limites de recursos",
        retries: "Tentativas repetidas",
        review: "Avaliação",
        review_link: "Link para Avaliação",
        review_page: "Página de avaliação",
        review_pages: "Páginas de avaliação",
        review_spotlight: "Avaliação em destaque",
        review_suggestions: "Sugestões de Avaliação",
        review_wall: "Mural de avaliações",
        review_velocity: "Avaliações por semana",
        reviewer: "Avaliador",
        reviews: "Avaliações",
        save_changes: "Salvar alterações",
        schedule: "Agendar",
        scrape_a_website: "Extrair de um site",
        search_engines: "Motores de busca",
        sections: "Seções",
        select_csv_file: "Selecione o arquivo CSV",
        select_project: "Selecionar um projeto",
        selecting_project: "Selecionando Projeto",
        sending_domain: "Domínio de envio",
        sending_limits: "Limites de Envio",
        sentiment: "Sentimento",
        settings: "Configurações",
        setup: "Configurar",
        setup_basics: "Sua estratégia de Solicitação",
        setup_business: "Vamos começar",
        setup_google: "Seu perfil do Google Meu Negócio",
        setup_trusted: "Aprovado por mais de 5.000 empresas.",
        showcase: "Showcase",
        sign_up: "Inscrever-se",
        signature: "Assinatura",
        signatures: "Assinaturas",
        signing_in: "Fazendo login",
        single_sign_on: "Autenticação única",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "Mensagens SMS",
        sms_usage: "Uso de SMS",
        smtp_configuration: "Configuração SMTP",
        source: "Fonte",
        sources: "Fontes",
        star_mix: "Detalhamento das avaliações",
        space: "Espaço de trabalho",
        spaces: "Espaços de trabalho",
        stats: "Estatísticas",
        sub_processors: "Subprocessadores",
        success_page: "Página de Sucesso",
        summary: "Resumo",
        tag: "Etiqueta",
        tag_rule: "Regra de marcação",
        tags: "Etiquetas",
        team_members: "Membros da equipe",
        template: "Modelo",
        templates: "Modelos",
        terms_of_service: "Termos de Serviço",
        two_factor_authentication: "Autenticação de dois fatores",
        unable_to_complete_request: "Não foi possível concluir a solicitação.",
        unique_review_link: "Link de Avaliação exclusivo",
        unsent_messages: "Mensagens não enviadas",
        unsubscribe: "Cancelar inscrição",
        update_plan: "Plano de atualização",
        usage: "Uso",
        user: "Usuário",
        user_info: "Informações do usuário",
        verify_email_address: "Verificar endereço de e-mail",
        verifying_email: "Verificando e-mail",
        visibility: "Visibilidade",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Site",
        white_label_api: "API de marca branca",
        white_label_client_portal: "Portal do Cliente White Label",
        white_label_image_urls: "URLs de imagens de marca branca",
        white_label_sending_domain: "Domínio de Envio de Marca Branca",
        white_label_widget_tag: "Tag de widget de marca branca",
        widget: "Widget",
        widget_num: "Widget #{num}",
        widgets: "Widgets",
        your_plan: "Seu Plano"
    },
    tones: {
        apologetic: "Apologético",
        casual: "Casual",
        empathetic: "Empático",
        enthusiastic: "Entusiasmado",
        formal: "Formal",
        friendly: "Amigável",
        grateful: "Grato",
        humorous: "Bem humorado",
        informative: "Informativo"
    },
    widgets: {
        labels: {
            alignment: "Alinhamento",
            animation: "Animação",
            autoplay: "Reprodução automática",
            autoplay_delay: "Atraso de reprodução automática",
            avatar: "Avatar",
            background_color: "Cor de fundo",
            border: "Fronteira",
            border_color: "Cor da borda",
            border_radius: "Raio de Borda",
            border_width: "Largura da Borda",
            carousel: "Carrossel",
            colors: "Cores",
            company: "Empresa",
            customer: "Cliente",
            customer_position: "Posição do Cliente",
            date: "Data",
            delay: "Atraso",
            design: "Design",
            design_prompt_placeholder: "Exemplo: Suave e minimalista, com estrelas douradas e cantos arredondados.",
            drop_shadow: "Sombra projetada",
            duration: "Duração",
            filters: "Filtros",
            font: "Fonte",
            font_emphasis: "Ênfase na fonte",
            font_family: "Família de fontes",
            font_size: "Tamanho da fonte",
            include_hidden: "Incluir Avaliações ocultas",
            layout: "Layout",
            limit: "Avaliações por página",
            location_ids: "Locais",
            marquee: "Marquee",
            max_slides: "Slides Máximos",
            max_width: "Largura Máxima",
            name_convention: "Nome",
            padding: "Preenchimento",
            pagination: "Paginação",
            quotes: "Citações",
            rating: "Nota",
            rating_round: "Arredondamento",
            rating_round_hundredth: "Centésimo mais próximo (4,94)",
            rating_round_tenth: "Décimo mais próximo (4,9)",
            review: "Avaliação",
            review_chars: "Duração da Avaliação",
            review_count: "Contagem de Avaliação",
            review_id: "Avaliação",
            review_ids: "Avaliações",
            review_ids_for_faces: "Avaliações para Faces",
            reviews: "Avaliações",
            schema: "Esquema",
            schema_name: "Nome da empresa",
            schema_type: "Tipo de negócio",
            score: "Nota mais baixa",
            show_on_mobile: "Mostrar no celular",
            slider: "Controle deslizante",
            sort: "Organizar",
            source: "Fonte",
            source_ids: "Fontes",
            source_position: "Posição da fonte",
            speed: "Velocidade",
            star_color: "Cor da estrela",
            star_display: "Exibição de estrelas",
            star_size: "Tamanho da estrela",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Etiquetas",
            take: "Número máximo de Avaliações",
            text_color: "Cor do texto",
            truncate: "Resumir Avaliação",
            visible_slides: "Slides visíveis",
            width: "Largura"
        },
        types: {
            badge: "Distintivo",
            carousel: "Carrossel",
            carousel_dynamic: "Carrossel Dinâmico",
            corner: "Canto",
            corner_dynamic: "Canto dinâmico",
            faces: "Rostos",
            headline: "Título",
            highlights: "Destaques",
            marquee: "Marquee",
            spotlight: "Destaque",
            wall: "Mural"
        }
    }
}